PJQ.views.projectInvites = {};

PJQ.views.projectInvites.ProjectInvite = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Project-Invite'),
		project: null,
		emailTemplates: [],
		onChange: _.noop,
		isShowQuickAdd: false,
		isShowAttachments: false,
		defaultTemplateKey: null
	},
	beforeRender: function () {
		if (!this.options.project.inviteSettings) {
			this.options.project.inviteSettings = {
				sendEmail: true,
				sendFaxIfNoEmail: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL),
				sendFaxIfEmailFails: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED),
				sendFaxAlways: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS),
				responseDue: this.options.project.get('responseDueDate') === 'ASAP' ? 'ASAP' : this.options.project.get('bidsDue') ? PJQ.helpers.dateHelpers.getDateString(new Date(this.options.project.get('bidsDue')), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD, false) : null,
				responseDueLabel: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) : "Response Due",
				quickAdd: '',
				attachments: new PJQ.collections.files.Files(),
				uploaderGuid: PJQ.helpers.guid(),
				privateFolders: new PJQ.collections.files.Files(),
				templateKey: this.options.defaultTemplateKey,
				replyTo: null
			};
		}

		if (!this.options.project.inviteSettings.emailTemplate) {
			this.options.project.inviteSettings.emailTemplate = this.options.emailTemplates[0];
			if (this.options.project.inviteSettings.templateKey) {
				_.each(this.options.emailTemplates, _.bind(function (item) {
					if (item.get('templateKey') === this.options.project.inviteSettings.templateKey)
						this.options.project.inviteSettings.emailTemplate = item;
				}, this));
			}

		}

		this.renderData = {
			emailTemplates: this.options.emailTemplates,
			replyToContacts: this.options.replyToContacts,
			isShowQuickAdd: this.options.isShowQuickAdd,
			isShowAttachments: this.options.isShowAttachments,
			responseDueLabel: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) : "Response Due",
			activeView: ''
		};
	},
	afterRender: function () {

		if (this.options.isShowQuickAdd) {
			this.$('input.quick-add-list').val(this.options.project.inviteSettings.quickAdd);

			this.$('input.quick-add-list').on('change keyup', _.bind(function () {
				this.options.project.inviteSettings.quickAdd = this.$('input.quick-add-list').val();
				if (typeof this.options.onChange === 'function')
					typeof this.options.onChange();
			}, this));

		}

		if (_.size(this.options.replyToContacts) > 0) {
			this.replyToSelectPicker = new PJQ.inputs.Selectpicker({
					el: this.$('.reply-to'),
					isIntChoices: true,
					defaultValue: this.options.project.inviteSettings.replyTo ? this.options.project.inviteSettings.replyTo : 0,
					onChange: _.bind(function(value) {
						this.options.project.inviteSettings.replyTo = value ? value : null;
					}, this)
				});

		}

		this.$('input.message-subject').val(this.options.project.inviteSettings.messageSubject);
		this.$('input.message-subject').on('change keyup', _.bind(function () {
			this.options.project.inviteSettings.messageSubject = this.$('input.message-subject').val();
			if (typeof this.options.onChange === 'function')
				typeof this.options.onChange();

			this.queuePreview();
		}, this));

		if (this.options.project.inviteSettings.responseDue === 'ASAP')
			this.$('input.response-due').val('').prop('disabled', true);
		else {
			if (this.options.project.inviteSettings && this.options.project.inviteSettings.responseDue === '1970-01-01')
				this.$('input.response-due').val('');
			else
				this.$('input.response-due').val(this.options.project.inviteSettings.responseDue);
		}

		this.$('input.response-due').on('change keyup', _.bind(function () {
			this.options.project.inviteSettings.responseDue = this.$('input.response-due').val();
			if (typeof this.options.onChange === 'function')
				typeof this.options.onChange();

			this.queuePreview();
		}, this));

		this.$('input.response-due-asap').prop('checked', (this.options.project.inviteSettings.responseDue === 'ASAP'));

		this.$('input.response-due-asap').on('click', _.bind(function () {
			this.options.project.inviteSettings.responseDue = this.$('input.response-due-asap').prop('checked') ? 'ASAP' : this.$('input.response-due').val();
			this.$('input.response-due').val('').prop('disabled', this.$('input.response-due-asap').prop('checked'));
			if (typeof this.options.onChange === 'function')
				typeof this.options.onChange();

			this.renderPreview();
		}, this));

		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_DISABLE_RESPONSE_DUE)) {
			this.$('input.response-due, input.response-due-asap').prop('disabled', true);
		}

		this.messageType = new PJQ.inputs.Selectpicker({
			el: this.$('select.message-type'),
			defaultValue: this.options.project.inviteSettings.emailTemplate ? this.options.project.inviteSettings.emailTemplate.get('templateKey') : this.options.emailTemplates[0].get('templateKey'),
			dropupAuto: false,
			onChange: _.bind(function () {
				this.messageTypeSelected(this.messageType.getValue());
			}, this)
		});

		this.responseType = new PJQ.inputs.Selectpicker({
			el: this.$('select.response-type'),
			defaultValue: this.options.project.inviteSettings.responseType ? this.options.project.inviteSettings.responseType : 'NONE',
			onChange: _.bind(function (value) {
				if (value === 'NONE')
					value = '';
				this.options.project.inviteSettings.responseType = value;
				if (typeof this.options.onChange === 'function')
					typeof this.options.onChange();

				this.renderPreview();
			}, this),
		});

		if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_FAX)) {
			this.$('select.send-options option[value="2"]').prop('hidden', true);
			this.$('select.send-options option[value="3"]').prop('hidden', true);
			this.$('select.send-options option[value="4"]').prop('hidden', true);
		}
		else {
			this.$('select.send-options option[value="2"]').prop('selected', PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL));
			this.$('select.send-options option[value="3"]').prop('selected', PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED));
			this.$('select.send-options option[value="4"]').prop('selected', PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS));
		}

		let sendOptions = ["1"];

		if (this.options.project.inviteSettings.sendFaxIfNoEmail)
			sendOptions.push("2");

		if (this.options.project.inviteSettings.sendFaxIfEmailFails)
			sendOptions.push("3");

		if (this.options.project.inviteSettings.sendFaxAlways)
			sendOptions.push("4");

		new PJQ.inputs.SelectpickerProjectMessageSendOptions({
			el: this.$('select.send-options'),
			onChange: _.bind(function (value) {
				this.options.project.inviteSettings.sendFaxIfNoEmail = value.indexOf("2") !== -1;
				this.options.project.inviteSettings.sendFaxIfEmailFails = value.indexOf("3") !== -1;
				this.options.project.inviteSettings.sendFaxAlways = value.indexOf("4") !== -1;
				if (typeof this.options.onChange === 'function')
					typeof this.options.onChange();
			}, this),
			isMultiple: true,
			isIntChoices: false,
			hideDisabled: false,
			noneSelectedText: 'No Options Selected',
			defaultValue: sendOptions,
			exclusiveChoices: ["4"]
		});

		this.messageBodyEditor = new PJQ.inputs.HTMLEditor({
			el: this.$('div.invite-message'),
			defaultValue: this.options.project.inviteSettings.messageBody,
			onInit: _.bind(function () {
				let tokenBtn = '<button type="button" class="btn btn-default btn-sm btn-small tokenBtn" title="Token List" data-event="something" tabindex="-1">Tokens</button>',
					tokenGroup = '<div class="note-file btn-group">' + tokenBtn + '</div>';

				$(tokenGroup).prependTo(this.$('.note-toolbar'));
				this.$('.tokenBtn').tooltip({container: 'body', placement: 'bottom'});
				this.$('.tokenBtn').click(function (event) {
					// load token dialog
				});

			}, this),
			onChange: _.bind(function (contents) {
				this.options.project.inviteSettings.messageBody = contents;
				if (typeof this.options.onChange === 'function')
					typeof this.options.onChange();

				this.queuePreview();
			}, this)
		});

		if (this.options.isShowAttachments) {
			this.uploader = new PJQ.views.files.FileUploaderGrid({
				el: this.$('.uploader'),
				collection: this.options.project.inviteSettings.attachments,
				uuid: this.options.project.inviteSettings.uploaderGuid
			});

			this.options.project.fetchAttachments({
				isShared: false,
				includeDrawings: false
			}, _.bind(function (attachments) {
				this.privateFolders = attachments;
				if (_.size(attachments.models) > 1)
					this.$('.private-folders').closest('div.form-group').show();

				new PJQ.views.projects.ProjectAttachments({
					el: this.$('.private-folders'),
					collection: attachments,
					project: this.options.project,
					isHideDownload: true,
					isHideDrawings: true,
					preventSelectAll: true,
					selectedAttachments: this.options.project.inviteSettings.privateFolders,
					onChange: _.bind(function (attachments) {
						this.options.project.inviteSettings.privateFolders = attachments;
					}, this)
				});
			}, this));
		}

		if (!this.options.project.inviteSettings.messageType)
			this.messageTypeSelected(this.options.project.inviteSettings.templateKey ? this.options.project.inviteSettings.templateKey : this.options.emailTemplates[0].get('templateKey'));
		else
			this.renderPreview();

	},
	messageTypeSelected: function (templateKey) {
		let emailTemplate = _.filter(this.options.emailTemplates, function (template) {
			return template.get('templateKey') === templateKey
		})[0];
		this.options.project.inviteSettings.emailTemplate = emailTemplate;
		this.options.project.inviteSettings.messageType = emailTemplate.get('templateKey');
		this.options.project.inviteSettings.messageSubject = emailTemplate.get('subjectTemplate');
		this.options.project.inviteSettings.messageBody = emailTemplate.get('defaultTextTemplate');
		this.options.project.inviteSettings.responseType = emailTemplate.get('projectMessageType');

		this.$('.message-subject').val(this.options.project.inviteSettings.messageSubject);
		this.responseType.setValue(emailTemplate.get('projectMessageType') ? emailTemplate.get('projectMessageType') : "NONE");
		this.messageBodyEditor.setValue(emailTemplate.get('defaultTextTemplate'));

		if (typeof this.options.onChange === 'function')
			typeof this.options.onChange();

		this.renderPreview();
	},
	queuePreview: function() {
		clearTimeout(this.saveTimeout);
		this.saveTimeout = setTimeout(_.bind(function () {
			this.renderPreview();
		}, this), 500);
	},
	renderPreview: function() {
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.get('projectId')
			},
			{
				endpoint: 'projectmessagepreview'
			}
		], [
			{
				parameter: "templateKey",
				value: this.options.project.inviteSettings.emailTemplate.get('templateKey')
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint
		}).post().done(_.bind(function (data) {
			this.options.tokens = data;

			let subject = this.options.project.inviteSettings.messageSubject,
				body = this.options.project.inviteSettings.emailTemplate.get('bodyTemplate');

			this.options.tokens.projectMessage.responseType = 'N/A';
			if (this.options.project.inviteSettings.responseType === 'PROJECT')
				this.options.tokens.projectMessage.responseType = 'ACCEPT/DECLINE';
			else if (this.options.project.inviteSettings.responseType === 'MESSAGE')
				this.options.tokens.projectMessage.responseType = 'YES/NO';

			this.options.tokens.projectMessage.bidDueDate = this.options.project.inviteSettings.responseDue;
			this.options.tokens.projectMessage.responseDueDate = this.options.project.inviteSettings.responseDue;

			this.options.tokens.projectMessage.responseDueDateWithBy = '&nbsp;by&nbsp;' + (this.options.project.inviteSettings.responseDue ? this.options.project.inviteSettings.responseDue : 'N/A');

			this.options.tokens.projectMessage.messageBody = this.translateTokens(this.options.project.inviteSettings.messageBody);
			this.$('.message-preview-subject').html(this.translateTokens(subject));
			this.$('.message-preview-body').html(this.translateTokens(body)).scrollTop(0);

		}, this)).fail(function () {
		});

	},
	translateTokens: function (input) {
		input = input.replace(/\[Sender.Username\]/g, this.options.tokens.sender.username);
		input = input.replace(/\[Sender.Company\]/g, this.options.tokens.sender.company);
		input = input.replace(/\[Sender.Contact\]/g, this.options.tokens.sender.contact);
		input = input.replace(/\[Sender.Address1\]/g, this.options.tokens.sender.address1);
		input = input.replace(/\[Sender.Address2\]/g, this.options.tokens.sender.address2);
		input = input.replace(/\[Sender.City\]/g, this.options.tokens.sender.city);
		input = input.replace(/\[Sender.State\]/g, this.options.tokens.sender.state);
		input = input.replace(/\[Sender.Zip\]/g, this.options.tokens.sender.zip);
		input = input.replace(/\[Sender.Country\]/g, this.options.tokens.sender.country);
		input = input.replace(/\[Sender.Phone\]/g, this.options.tokens.sender.phone);
		input = input.replace(/\[Sender.PhoneExtension\]/g, this.options.tokens.sender.phoneExtension);
		input = input.replace(/\[Sender.Fax\]/g, this.options.tokens.sender.fax);
		input = input.replace(/\[Sender.Cell\]/g, this.options.tokens.sender.cell);
		input = input.replace(/\[Sender.Email\]/g, this.options.tokens.sender.email);
		input = input.replace(/\[Sender.EmailLogoURL\]/g, this.options.tokens.sender.emailLogoURL);
		input = input.replace(/\[Sender.FullAddress\]/g, this.options.tokens.sender.fullAddress);
		input = input.replace(/\[Sender.Email2\]/g, this.options.tokens.sender.email2);
		input = input.replace(/\[Sender.Signature\]/g, this.options.tokens.sender.signature);
		input = input.replace(/\[Sender.UserType\]/g, this.options.tokens.sender.userType);
		input = input.replace(/\[Sender.CustomFieldLabel1\]/g, this.options.tokens.sender.customFieldLabel1);
		input = input.replace(/\[Sender.CustomFieldValue1\]/g, this.options.tokens.sender.customFieldValue1);
		input = input.replace(/\[Sender.CustomFieldLabel2\]/g, this.options.tokens.sender.customFieldLabel2);
		input = input.replace(/\[Sender.CustomFieldValue2\]/g, this.options.tokens.sender.customFieldValue2);
		input = input.replace(/\[Sender.CustomFieldLabel3\]/g, this.options.tokens.sender.customFieldLabel3);
		input = input.replace(/\[Sender.CustomFieldValue3\]/g, this.options.tokens.sender.customFieldValue3);
		input = input.replace(/\[Sender.CustomFieldLabel4\]/g, this.options.tokens.sender.customFieldLabel4);
		input = input.replace(/\[Sender.CustomFieldValue4\]/g, this.options.tokens.sender.customFieldValue4);
		input = input.replace(/\[Sender.CustomFieldLabel5\]/g, this.options.tokens.sender.customFieldLabel5);
		input = input.replace(/\[Sender.CustomFieldValue5\]/g, this.options.tokens.sender.customFieldValue5);
		input = input.replace(/\[Sender.CustomFieldLabel6\]/g, this.options.tokens.sender.customFieldLabel6);
		input = input.replace(/\[Sender.CustomFieldValue6\]/g, this.options.tokens.sender.customFieldValue6);
		input = input.replace(/\[Sender.CustomFieldLabel7\]/g, this.options.tokens.sender.customFieldLabel7);
		input = input.replace(/\[Sender.CustomFieldValue7\]/g, this.options.tokens.sender.customFieldValue7);
		input = input.replace(/\[Sender.CustomFieldLabel8\]/g, this.options.tokens.sender.customFieldLabel8);
		input = input.replace(/\[Sender.CustomFieldValue8\]/g, this.options.tokens.sender.customFieldValue8);
		input = input.replace(/\[Sender.CustomFieldLabel9\]/g, this.options.tokens.sender.customFieldLabel9);
		input = input.replace(/\[Sender.CustomFieldValue9\]/g, this.options.tokens.sender.customFieldValue9);
		input = input.replace(/\[Sender.CustomFieldLabel10\]/g, this.options.tokens.sender.customFieldLabel10);
		input = input.replace(/\[Sender.CustomFieldValue10\]/g, this.options.tokens.sender.customFieldValue10);

		input = input.replace(/\[Sender.CustomFieldValue1_CLBR\]/g, this.options.tokens.sender.customFieldValue1_CLBR);
		input = input.replace(/\[Sender.CustomFieldValue2_CLBR\]/g, this.options.tokens.sender.customFieldValue2_CLBR);
		input = input.replace(/\[Sender.CustomFieldValue3_CLBR\]/g, this.options.tokens.sender.customFieldValue3_CLBR);
		input = input.replace(/\[Sender.CustomFieldValue4_CLBR\]/g, this.options.tokens.sender.customFieldValue4_CLBR);
		input = input.replace(/\[Sender.CustomFieldValue5_CLBR\]/g, this.options.tokens.sender.customFieldValue5_CLBR);
		input = input.replace(/\[Sender.CustomFieldValue6_CLBR\]/g, this.options.tokens.sender.customFieldValue6_CLBR);
		input = input.replace(/\[Sender.CustomFieldValue7_CLBR\]/g, this.options.tokens.sender.customFieldValue7_CLBR);
		input = input.replace(/\[Sender.CustomFieldValue8_CLBR\]/g, this.options.tokens.sender.customFieldValue8_CLBR);
		input = input.replace(/\[Sender.CustomFieldValue9_CLBR\]/g, this.options.tokens.sender.customFieldValue9_CLBR);
		input = input.replace(/\[Sender.CustomFieldValue10_CLBR\]/g, this.options.tokens.sender.customFieldValue10_CLBR);


		input = input.replace(/\[SenderPM.Username\]/g, this.options.tokens.senderPM.username);
		input = input.replace(/\[SenderPM.Company\]/g, this.options.tokens.senderPM.company);
		input = input.replace(/\[SenderPM.Contact\]/g, this.options.tokens.senderPM.contact);
		input = input.replace(/\[SenderPM.Address1\]/g, this.options.tokens.senderPM.address1);
		input = input.replace(/\[SenderPM.Address2\]/g, this.options.tokens.senderPM.address2);
		input = input.replace(/\[SenderPM.City\]/g, this.options.tokens.senderPM.city);
		input = input.replace(/\[SenderPM.State\]/g, this.options.tokens.senderPM.state);
		input = input.replace(/\[SenderPM.Zip\]/g, this.options.tokens.senderPM.zip);
		input = input.replace(/\[SenderPM.Country\]/g, this.options.tokens.senderPM.country);
		input = input.replace(/\[SenderPM.Phone\]/g, this.options.tokens.senderPM.phone);
		input = input.replace(/\[SenderPM.PhoneExtension\]/g, this.options.tokens.senderPM.phoneExtension);
		input = input.replace(/\[SenderPM.Fax\]/g, this.options.tokens.senderPM.fax);
		input = input.replace(/\[SenderPM.Cell\]/g, this.options.tokens.senderPM.cell);
		input = input.replace(/\[SenderPM.Email\]/g, this.options.tokens.senderPM.email);
		input = input.replace(/\[SenderPM.EmailLogoURL\]/g, this.options.tokens.senderPM.emailLogoURL);
		input = input.replace(/\[SenderPM.FullAddress\]/g, this.options.tokens.senderPM.fullAddress);
		input = input.replace(/\[SenderPM.Email2\]/g, this.options.tokens.senderPM.email2);
		input = input.replace(/\[SenderPM.UserType\]/g, this.options.tokens.senderPM.userType);
		input = input.replace(/\[SenderPM.CustomFieldLabel1\]/g, this.options.tokens.senderPM.customFieldLabel1);
		input = input.replace(/\[SenderPM.CustomFieldValue1\]/g, this.options.tokens.senderPM.customFieldValue1);
		input = input.replace(/\[SenderPM.CustomFieldLabel2\]/g, this.options.tokens.senderPM.customFieldLabel2);
		input = input.replace(/\[SenderPM.CustomFieldValue2\]/g, this.options.tokens.senderPM.customFieldValue2);
		input = input.replace(/\[SenderPM.CustomFieldLabel3\]/g, this.options.tokens.senderPM.customFieldLabel3);
		input = input.replace(/\[SenderPM.CustomFieldValue3\]/g, this.options.tokens.senderPM.customFieldValue3);
		input = input.replace(/\[SenderPM.CustomFieldLabel4\]/g, this.options.tokens.senderPM.customFieldLabel4);
		input = input.replace(/\[SenderPM.CustomFieldValue4\]/g, this.options.tokens.senderPM.customFieldValue4);
		input = input.replace(/\[SenderPM.CustomFieldLabel5\]/g, this.options.tokens.senderPM.customFieldLabel5);
		input = input.replace(/\[SenderPM.CustomFieldValue5\]/g, this.options.tokens.senderPM.customFieldValue5);
		input = input.replace(/\[SenderPM.CustomFieldLabel6\]/g, this.options.tokens.senderPM.customFieldLabel6);
		input = input.replace(/\[SenderPM.CustomFieldValue6\]/g, this.options.tokens.senderPM.customFieldValue6);
		input = input.replace(/\[SenderPM.CustomFieldLabel7\]/g, this.options.tokens.senderPM.customFieldLabel7);
		input = input.replace(/\[SenderPM.CustomFieldValue7\]/g, this.options.tokens.senderPM.customFieldValue7);
		input = input.replace(/\[SenderPM.CustomFieldLabel8\]/g, this.options.tokens.senderPM.customFieldLabel8);
		input = input.replace(/\[SenderPM.CustomFieldValue8\]/g, this.options.tokens.senderPM.customFieldValue8);
		input = input.replace(/\[SenderPM.CustomFieldLabel9\]/g, this.options.tokens.senderPM.customFieldLabel9);
		input = input.replace(/\[SenderPM.CustomFieldValue9\]/g, this.options.tokens.senderPM.customFieldValue9);
		input = input.replace(/\[SenderPM.CustomFieldLabel10\]/g, this.options.tokens.senderPM.customFieldLabel10);
		input = input.replace(/\[SenderPM.CustomFieldValue10\]/g, this.options.tokens.senderPM.customFieldValue10);

		input = input.replace(/\[SenderPM.CustomFieldValue1_CLBR\]/g, this.options.tokens.senderPM.customFieldValue1_CLBR);
		input = input.replace(/\[SenderPM.CustomFieldValue2_CLBR\]/g, this.options.tokens.senderPM.customFieldValue2_CLBR);
		input = input.replace(/\[SenderPM.CustomFieldValue3_CLBR\]/g, this.options.tokens.senderPM.customFieldValue3_CLBR);
		input = input.replace(/\[SenderPM.CustomFieldValue4_CLBR\]/g, this.options.tokens.senderPM.customFieldValue4_CLBR);
		input = input.replace(/\[SenderPM.CustomFieldValue5_CLBR\]/g, this.options.tokens.senderPM.customFieldValue5_CLBR);
		input = input.replace(/\[SenderPM.CustomFieldValue6_CLBR\]/g, this.options.tokens.senderPM.customFieldValue6_CLBR);
		input = input.replace(/\[SenderPM.CustomFieldValue7_CLBR\]/g, this.options.tokens.senderPM.customFieldValue7_CLBR);
		input = input.replace(/\[SenderPM.CustomFieldValue8_CLBR\]/g, this.options.tokens.senderPM.customFieldValue8_CLBR);
		input = input.replace(/\[SenderPM.CustomFieldValue9_CLBR\]/g, this.options.tokens.senderPM.customFieldValue9_CLBR);
		input = input.replace(/\[SenderPM.CustomFieldValue10_CLBR\]/g, this.options.tokens.senderPM.customFieldValue10_CLBR);


		input = input.replace(/\[ProjectContact2.Username\]/g, this.options.tokens.projectContact2.username);
		input = input.replace(/\[ProjectContact2.Company\]/g, this.options.tokens.projectContact2.company);
		input = input.replace(/\[ProjectContact2.Contact\]/g, this.options.tokens.projectContact2.contact);
		input = input.replace(/\[ProjectContact2.Address1\]/g, this.options.tokens.projectContact2.address1);
		input = input.replace(/\[ProjectContact2.Address2\]/g, this.options.tokens.projectContact2.address2);
		input = input.replace(/\[ProjectContact2.City\]/g, this.options.tokens.projectContact2.city);
		input = input.replace(/\[ProjectContact2.State\]/g, this.options.tokens.projectContact2.state);
		input = input.replace(/\[ProjectContact2.Zip\]/g, this.options.tokens.projectContact2.zip);
		input = input.replace(/\[ProjectContact2.Country\]/g, this.options.tokens.projectContact2.country);
		input = input.replace(/\[ProjectContact2.Phone\]/g, this.options.tokens.projectContact2.phone);
		input = input.replace(/\[ProjectContact2.PhoneExtension\]/g, this.options.tokens.projectContact2.phoneExtension);
		input = input.replace(/\[ProjectContact2.Fax\]/g, this.options.tokens.projectContact2.fax);
		input = input.replace(/\[ProjectContact2.Cell\]/g, this.options.tokens.projectContact2.cell);
		input = input.replace(/\[ProjectContact2.Email\]/g, this.options.tokens.projectContact2.email);
		input = input.replace(/\[ProjectContact2.EmailLogoURL\]/g, this.options.tokens.projectContact2.emailLogoURL);
		input = input.replace(/\[ProjectContact2.FullAddress\]/g, this.options.tokens.projectContact2.fullAddress);
		input = input.replace(/\[ProjectContact2.Email2\]/g, this.options.tokens.projectContact2.email2);
		input = input.replace(/\[ProjectContact2.Signature\]/g, this.options.tokens.projectContact2.signature);
		input = input.replace(/\[ProjectContact2.UserType\]/g, this.options.tokens.projectContact2.userType);
		input = input.replace(/\[ProjectContact2.CustomFieldLabel1\]/g, this.options.tokens.projectContact2.customFieldLabel1);
		input = input.replace(/\[ProjectContact2.CustomFieldValue1\]/g, this.options.tokens.projectContact2.customFieldValue1);
		input = input.replace(/\[ProjectContact2.CustomFieldLabel2\]/g, this.options.tokens.projectContact2.customFieldLabel2);
		input = input.replace(/\[ProjectContact2.CustomFieldValue2\]/g, this.options.tokens.projectContact2.customFieldValue2);
		input = input.replace(/\[ProjectContact2.CustomFieldLabel3\]/g, this.options.tokens.projectContact2.customFieldLabel3);
		input = input.replace(/\[ProjectContact2.CustomFieldValue3\]/g, this.options.tokens.projectContact2.customFieldValue3);
		input = input.replace(/\[ProjectContact2.CustomFieldLabel4\]/g, this.options.tokens.projectContact2.customFieldLabel4);
		input = input.replace(/\[ProjectContact2.CustomFieldValue4\]/g, this.options.tokens.projectContact2.customFieldValue4);
		input = input.replace(/\[ProjectContact2.CustomFieldLabel5\]/g, this.options.tokens.projectContact2.customFieldLabel5);
		input = input.replace(/\[ProjectContact2.CustomFieldValue5\]/g, this.options.tokens.projectContact2.customFieldValue5);
		input = input.replace(/\[ProjectContact2.CustomFieldLabel6\]/g, this.options.tokens.projectContact2.customFieldLabel6);
		input = input.replace(/\[ProjectContact2.CustomFieldValue6\]/g, this.options.tokens.projectContact2.customFieldValue6);
		input = input.replace(/\[ProjectContact2.CustomFieldLabel7\]/g, this.options.tokens.projectContact2.customFieldLabel7);
		input = input.replace(/\[ProjectContact2.CustomFieldValue7\]/g, this.options.tokens.projectContact2.customFieldValue7);
		input = input.replace(/\[ProjectContact2.CustomFieldLabel8\]/g, this.options.tokens.projectContact2.customFieldLabel8);
		input = input.replace(/\[ProjectContact2.CustomFieldValue8\]/g, this.options.tokens.projectContact2.customFieldValue8);
		input = input.replace(/\[ProjectContact2.CustomFieldLabel9\]/g, this.options.tokens.projectContact2.customFieldLabel9);
		input = input.replace(/\[ProjectContact2.CustomFieldValue9\]/g, this.options.tokens.projectContact2.customFieldValue9);
		input = input.replace(/\[ProjectContact2.CustomFieldLabel10\]/g, this.options.tokens.projectContact2.customFieldLabel10);
		input = input.replace(/\[ProjectContact2.CustomFieldValue10\]/g, this.options.tokens.projectContact2.customFieldValue10);

		input = input.replace(/\[ProjectContact2.CustomFieldValue1_CLBR\]/g, this.options.tokens.projectContact2.customFieldValue1_CLBR);
		input = input.replace(/\[ProjectContact2.CustomFieldValue2_CLBR\]/g, this.options.tokens.projectContact2.customFieldValue2_CLBR);
		input = input.replace(/\[ProjectContact2.CustomFieldValue3_CLBR\]/g, this.options.tokens.projectContact2.customFieldValue3_CLBR);
		input = input.replace(/\[ProjectContact2.CustomFieldValue4_CLBR\]/g, this.options.tokens.projectContact2.customFieldValue4_CLBR);
		input = input.replace(/\[ProjectContact2.CustomFieldValue5_CLBR\]/g, this.options.tokens.projectContact2.customFieldValue5_CLBR);
		input = input.replace(/\[ProjectContact2.CustomFieldValue6_CLBR\]/g, this.options.tokens.projectContact2.customFieldValue6_CLBR);
		input = input.replace(/\[ProjectContact2.CustomFieldValue7_CLBR\]/g, this.options.tokens.projectContact2.customFieldValue7_CLBR);
		input = input.replace(/\[ProjectContact2.CustomFieldValue8_CLBR\]/g, this.options.tokens.projectContact2.customFieldValue8_CLBR);
		input = input.replace(/\[ProjectContact2.CustomFieldValue9_CLBR\]/g, this.options.tokens.projectContact2.customFieldValue9_CLBR);
		input = input.replace(/\[ProjectContact2.CustomFieldValue10_CLBR\]/g, this.options.tokens.projectContact2.customFieldValue10_CLBR);

		input = input.replace(/\[Recipient.Company\]/g, this.options.tokens.recipient.company);
		input = input.replace(/\[Recipient.Contact\]/g, this.options.tokens.recipient.contact);
		input = input.replace(/\[Recipient.FirstName\]/g, this.options.tokens.recipient.firstName);
		input = input.replace(/\[Recipient.Title\]/g, this.options.tokens.recipient.title);
		input = input.replace(/\[Recipient.Address1\]/g, this.options.tokens.recipient.address1);
		input = input.replace(/\[Recipient.Address2\]/g, this.options.tokens.recipient.address2);
		input = input.replace(/\[Recipient.City\]/g, this.options.tokens.recipient.city);
		input = input.replace(/\[Recipient.State\]/g, this.options.tokens.recipient.state);
		input = input.replace(/\[Recipient.Zip\]/g, this.options.tokens.recipient.zip);
		input = input.replace(/\[Recipient.Country\]/g, this.options.tokens.recipient.country);
		input = input.replace(/\[Recipient.Phone\]/g, this.options.tokens.recipient.phone);
		input = input.replace(/\[Recipient.PhoneExtension\]/g, this.options.tokens.recipient.phoneExtension);
		input = input.replace(/\[Recipient.Fax\]/g, this.options.tokens.recipient.fax);
		input = input.replace(/\[Recipient.Email\]/g, this.options.tokens.recipient.email);
		input = input.replace(/\[Recipient.EmailLogoURL\]/g, this.options.tokens.recipient.emailLogoURL);
		input = input.replace(/\[Recipient.FullAddress\]/g, this.options.tokens.recipient.fullAddress);

		input = input.replace(/\[Portal.URL\]/g, this.options.tokens.portal.url);
		input = input.replace(/\[Portal.Domain\]/g, this.options.tokens.portal.domain);
		input = input.replace(/\[DateTime.Today\]/g, this.options.tokens.dateTime.today);

		input = input.replace(/\[ProjectMessage.AccessKey\]/g, this.options.tokens.projectMessage.accessKey);
		input = input.replace(/\[ProjectMessage.RSVPURL\]/g, this.options.tokens.projectMessage.rsvpurl);
		input = input.replace(/\[ProjectMessage.RecipientGroupList\]/g, this.options.tokens.projectMessage.recipientGroupList);
		input = input.replace(/\[ProjectMessage.RecipientGroupListComma\]/g, this.options.tokens.projectMessage.recipientGroupListComma);
		input = input.replace(/\[ProjectMessage.ResponseDueLabel\]/g, this.options.tokens.projectMessage.responseDueLabel);
		input = input.replace(/\[ProjectMessage.MessageResponseDueLabel\]/g, this.options.tokens.projectMessage.messageResponseDueLabel);
		input = input.replace(/\[ProjectMessage.ResponseDueDate\]/g, this.options.tokens.projectMessage.responseDueDate);
		input = input.replace(/\[ProjectMessage.ResponseDueDateWithBy\]/g, this.options.tokens.projectMessage.responseDueDateWithBy ? this.options.tokens.projectMessage.responseDueDateWithBy : '');
		input = input.replace(/\[ProjectMessage.ResponseDueTime\]/g, this.options.tokens.projectMessage.responseDueTime);
		input = input.replace(/\[ProjectMessage.MessageSubject\]/g, this.options.tokens.projectMessage.messageSubject);
		input = input.replace(/\[ProjectMessage.MessageBody\]/g, this.options.tokens.projectMessage.messageBody);
		input = input.replace(/\[ProjectMessage.SentOnDate\]/g, this.options.tokens.projectMessage.sentOnDate);
		input = input.replace(/\[ProjectMessage.EstCompleteDate\]/g, this.options.tokens.projectMessage.estCompleteDate);
		input = input.replace(/\[ProjectMessage.EstStartDate\]/g, this.options.tokens.projectMessage.estStartDate);
		input = input.replace(/\[ProjectMessage.MessageType\]/g, this.options.tokens.projectMessage.messageType);
		input = input.replace(/\[ProjectMessage.ResponseType\]/g, this.options.tokens.projectMessage.responseType);
		input = input.replace(/\[ProjectMessage.MessageName\]/g, this.options.tokens.projectMessage.messageName);

		input = input.replace(/\[Project.ProjectId\]/g, this.options.tokens.project.projectId);
		input = input.replace(/\[Project.Name\]/g, this.options.tokens.project.name);
		input = input.replace(/\[Project.Address1\]/g, this.options.tokens.project.address1);
		input = input.replace(/\[Project.Address2\]/g, this.options.tokens.project.address2);
		input = input.replace(/\[Project.City\]/g, this.options.tokens.project.city);
		input = input.replace(/\[Project.State\]/g, this.options.tokens.project.state);
		input = input.replace(/\[Project.Zip\]/g, this.options.tokens.project.zip);
		input = input.replace(/\[Project.Country\]/g, this.options.tokens.project.country);
		input = input.replace(/\[Project.Notes\]/g, this.options.tokens.project.notes);
		input = input.replace(/\[Project.ResponseDueLabel\]/g, this.options.tokens.project.responseDueLabel);
		input = input.replace(/\[Project.MessageResponseDueLabel\]/g, this.options.tokens.project.messageResponseDueLabel);
		input = input.replace(/\[Project.ResponseDueDate\]/g, this.options.tokens.project.responseDueDate);
		input = input.replace(/\[Project.ResponseDueTime\]/g, this.options.tokens.project.responseDueTime);
		input = input.replace(/\[Project.ResponseDueShortTime\]/g, this.options.tokens.project.responseDueShortTime);
		input = input.replace(/\[Project.ResponseDueTimeZone\]/g, this.options.tokens.project.responseDueTimeZone);
		input = input.replace(/\[Project.ResponseDueDateWithBy\]/g, this.options.tokens.project.responseDueDateWithBy);
		input = input.replace(/\[Project.StartDate\]/g, this.options.tokens.project.startDate);
		input = input.replace(/\[Project.EndDate\]/g, this.options.tokens.project.endDate);
		input = input.replace(/\[Project.ProjectStatus\]/g, this.options.tokens.project.projectStatus);
		input = input.replace(/\[Project.CustomFieldLabel1\]/g, this.options.tokens.project.customFieldLabel1);
		input = input.replace(/\[Project.CustomFieldValue1\]/g, this.options.tokens.project.customFieldValue1);
		input = input.replace(/\[Project.CustomFieldLabel2\]/g, this.options.tokens.project.customFieldLabel2);
		input = input.replace(/\[Project.CustomFieldValue2\]/g, this.options.tokens.project.customFieldValue2);
		input = input.replace(/\[Project.CustomFieldLabel3\]/g, this.options.tokens.project.customFieldLabel3);
		input = input.replace(/\[Project.CustomFieldValue3\]/g, this.options.tokens.project.customFieldValue3);
		input = input.replace(/\[Project.CustomFieldLabel4\]/g, this.options.tokens.project.customFieldLabel4);
		input = input.replace(/\[Project.CustomFieldValue4\]/g, this.options.tokens.project.customFieldValue4);
		input = input.replace(/\[Project.CustomFieldLabel5\]/g, this.options.tokens.project.customFieldLabel5);
		input = input.replace(/\[Project.CustomFieldValue5\]/g, this.options.tokens.project.customFieldValue5);
		input = input.replace(/\[Project.CustomFieldLabel6\]/g, this.options.tokens.project.customFieldLabel6);
		input = input.replace(/\[Project.CustomFieldValue6\]/g, this.options.tokens.project.customFieldValue6);
		input = input.replace(/\[Project.CustomFieldLabel7\]/g, this.options.tokens.project.customFieldLabel7);
		input = input.replace(/\[Project.CustomFieldValue7\]/g, this.options.tokens.project.customFieldValue7);
		input = input.replace(/\[Project.CustomFieldLabel8\]/g, this.options.tokens.project.customFieldLabel8);
		input = input.replace(/\[Project.CustomFieldValue8\]/g, this.options.tokens.project.customFieldValue8);
		input = input.replace(/\[Project.CustomFieldLabel9\]/g, this.options.tokens.project.customFieldLabel9);
		input = input.replace(/\[Project.CustomFieldValue9\]/g, this.options.tokens.project.customFieldValue9);
		input = input.replace(/\[Project.CustomFieldLabel10\]/g, this.options.tokens.project.customFieldLabel10);
		input = input.replace(/\[Project.CustomFieldValue10\]/g, this.options.tokens.project.customFieldValue10);
		input = input.replace(/\[Project.CustomFieldLabel11\]/g, this.options.tokens.project.customFieldLabel11);
		input = input.replace(/\[Project.CustomFieldValue11\]/g, this.options.tokens.project.customFieldValue11);
		input = input.replace(/\[Project.CustomFieldLabel12\]/g, this.options.tokens.project.customFieldLabel12);
		input = input.replace(/\[Project.CustomFieldValue12\]/g, this.options.tokens.project.customFieldValue12);
		input = input.replace(/\[Project.CustomFieldLabel13\]/g, this.options.tokens.project.customFieldLabel13);
		input = input.replace(/\[Project.CustomFieldValue13\]/g, this.options.tokens.project.customFieldValue13);
		input = input.replace(/\[Project.CustomFieldLabel14\]/g, this.options.tokens.project.customFieldLabel14);
		input = input.replace(/\[Project.CustomFieldValue14\]/g, this.options.tokens.project.customFieldValue14);
		input = input.replace(/\[Project.CustomFieldLabel15\]/g, this.options.tokens.project.customFieldLabel15);
		input = input.replace(/\[Project.CustomFieldValue15\]/g, this.options.tokens.project.customFieldValue15);
		input = input.replace(/\[Project.CustomFieldLabel16\]/g, this.options.tokens.project.customFieldLabel16);
		input = input.replace(/\[Project.CustomFieldValue16\]/g, this.options.tokens.project.customFieldValue16);
		input = input.replace(/\[Project.CustomFieldLabel17\]/g, this.options.tokens.project.customFieldLabel17);
		input = input.replace(/\[Project.CustomFieldValue17\]/g, this.options.tokens.project.customFieldValue17);
		input = input.replace(/\[Project.CustomFieldLabel18\]/g, this.options.tokens.project.customFieldLabel18);
		input = input.replace(/\[Project.CustomFieldValue18\]/g, this.options.tokens.project.customFieldValue18);
		input = input.replace(/\[Project.CustomFieldLabel19\]/g, this.options.tokens.project.customFieldLabel19);
		input = input.replace(/\[Project.CustomFieldValue19\]/g, this.options.tokens.project.customFieldValue19);
		input = input.replace(/\[Project.CustomFieldLabel20\]/g, this.options.tokens.project.customFieldLabel20);
		input = input.replace(/\[Project.CustomFieldValue20\]/g, this.options.tokens.project.customFieldValue20);
		input = input.replace(/\[Project.CustomFieldLabel21\]/g, this.options.tokens.project.customFieldLabel21);
		input = input.replace(/\[Project.CustomFieldValue21\]/g, this.options.tokens.project.customFieldValue21);
		input = input.replace(/\[Project.CustomFieldLabel22\]/g, this.options.tokens.project.customFieldLabel22);
		input = input.replace(/\[Project.CustomFieldValue22\]/g, this.options.tokens.project.customFieldValue22);
		input = input.replace(/\[Project.CustomFieldLabel23\]/g, this.options.tokens.project.customFieldLabel23);
		input = input.replace(/\[Project.CustomFieldValue23\]/g, this.options.tokens.project.customFieldValue23);
		input = input.replace(/\[Project.CustomFieldLabel24\]/g, this.options.tokens.project.customFieldLabel24);
		input = input.replace(/\[Project.CustomFieldValue24\]/g, this.options.tokens.project.customFieldValue24);
		input = input.replace(/\[Project.CustomFieldLabel25\]/g, this.options.tokens.project.customFieldLabel25);
		input = input.replace(/\[Project.CustomFieldValue25\]/g, this.options.tokens.project.customFieldValue25);
		input = input.replace(/\[Project.CustomFieldLabel26\]/g, this.options.tokens.project.customFieldLabel26);
		input = input.replace(/\[Project.CustomFieldValue26\]/g, this.options.tokens.project.customFieldValue26);
		input = input.replace(/\[Project.CustomFieldLabel27\]/g, this.options.tokens.project.customFieldLabel27);
		input = input.replace(/\[Project.CustomFieldValue27\]/g, this.options.tokens.project.customFieldValue27);
		input = input.replace(/\[Project.CustomFieldLabel28\]/g, this.options.tokens.project.customFieldLabel28);
		input = input.replace(/\[Project.CustomFieldValue28\]/g, this.options.tokens.project.customFieldValue28);
		input = input.replace(/\[Project.CustomFieldLabel29\]/g, this.options.tokens.project.customFieldLabel29);
		input = input.replace(/\[Project.CustomFieldValue29\]/g, this.options.tokens.project.customFieldValue29);
		input = input.replace(/\[Project.CustomFieldLabel30\]/g, this.options.tokens.project.customFieldLabel30);
		input = input.replace(/\[Project.CustomFieldValue30\]/g, this.options.tokens.project.customFieldValue30);
		input = input.replace(/\[Project.CustomFieldLabel31\]/g, this.options.tokens.project.customFieldLabel31);
		input = input.replace(/\[Project.CustomFieldValue31\]/g, this.options.tokens.project.customFieldValue31);
		input = input.replace(/\[Project.CustomFieldLabel32\]/g, this.options.tokens.project.customFieldLabel32);
		input = input.replace(/\[Project.CustomFieldValue32\]/g, this.options.tokens.project.customFieldValue32);
		input = input.replace(/\[Project.CustomFieldLabel33\]/g, this.options.tokens.project.customFieldLabel33);
		input = input.replace(/\[Project.CustomFieldValue33\]/g, this.options.tokens.project.customFieldValue33);
		input = input.replace(/\[Project.CustomFieldLabel34\]/g, this.options.tokens.project.customFieldLabel34);
		input = input.replace(/\[Project.CustomFieldValue34\]/g, this.options.tokens.project.customFieldValue34);
		input = input.replace(/\[Project.CustomFieldLabel35\]/g, this.options.tokens.project.customFieldLabel35);
		input = input.replace(/\[Project.CustomFieldValue35\]/g, this.options.tokens.project.customFieldValue35);
		input = input.replace(/\[Project.CustomFieldLabel36\]/g, this.options.tokens.project.customFieldLabel36);
		input = input.replace(/\[Project.CustomFieldValue36\]/g, this.options.tokens.project.customFieldValue36);
		input = input.replace(/\[Project.CustomFieldLabel37\]/g, this.options.tokens.project.customFieldLabel37);
		input = input.replace(/\[Project.CustomFieldValue37\]/g, this.options.tokens.project.customFieldValue37);
		input = input.replace(/\[Project.CustomFieldLabel38\]/g, this.options.tokens.project.customFieldLabel38);
		input = input.replace(/\[Project.CustomFieldValue38\]/g, this.options.tokens.project.customFieldValue38);
		input = input.replace(/\[Project.CustomFieldLabel39\]/g, this.options.tokens.project.customFieldLabel39);
		input = input.replace(/\[Project.CustomFieldValue39\]/g, this.options.tokens.project.customFieldValue39);

		input = input.replace(/\[Project.CustomFieldValue26_CompanyName\]/g, this.options.tokens.project.customFieldValue26_CompanyName);
		input = input.replace(/\[Project.CustomFieldValue26_ContactName\]/g, this.options.tokens.project.customFieldValue26_ContactName);
		input = input.replace(/\[Project.CustomFieldValue26_ContactTitle\]/g, this.options.tokens.project.customFieldValue26_ContactTitle);
		input = input.replace(/\[Project.CustomFieldValue26_Address26\]/g, this.options.tokens.project.customFieldValue26_Address26);
		input = input.replace(/\[Project.CustomFieldValue26_Address2\]/g, this.options.tokens.project.customFieldValue26_Address2);
		input = input.replace(/\[Project.CustomFieldValue26_City\]/g, this.options.tokens.project.customFieldValue26_City);
		input = input.replace(/\[Project.CustomFieldValue26_StateProvince\]/g, this.options.tokens.project.customFieldValue26_StateProvince);
		input = input.replace(/\[Project.CustomFieldValue26_PostalCode\]/g, this.options.tokens.project.customFieldValue26_PostalCode);
		input = input.replace(/\[Project.CustomFieldValue26_Country\]/g, this.options.tokens.project.customFieldValue26_Country);
		input = input.replace(/\[Project.CustomFieldValue26_Phone\]/g, this.options.tokens.project.customFieldValue26_Phone);
		input = input.replace(/\[Project.CustomFieldValue26_Fax\]/g, this.options.tokens.project.customFieldValue26_Fax);
		input = input.replace(/\[Project.CustomFieldValue26_Cell\]/g, this.options.tokens.project.customFieldValue26_Cell);
		input = input.replace(/\[Project.CustomFieldValue26_Email\]/g, this.options.tokens.project.customFieldValue26_Email);

		input = input.replace(/\[Project.CustomFieldValue27_CompanyName\]/g, this.options.tokens.project.customFieldValue27_CompanyName);
		input = input.replace(/\[Project.CustomFieldValue27_ContactName\]/g, this.options.tokens.project.customFieldValue27_ContactName);
		input = input.replace(/\[Project.CustomFieldValue27_ContactTitle\]/g, this.options.tokens.project.customFieldValue27_ContactTitle);
		input = input.replace(/\[Project.CustomFieldValue27_Address27\]/g, this.options.tokens.project.customFieldValue27_Address27);
		input = input.replace(/\[Project.CustomFieldValue27_Address2\]/g, this.options.tokens.project.customFieldValue27_Address2);
		input = input.replace(/\[Project.CustomFieldValue27_City\]/g, this.options.tokens.project.customFieldValue27_City);
		input = input.replace(/\[Project.CustomFieldValue27_StateProvince\]/g, this.options.tokens.project.customFieldValue27_StateProvince);
		input = input.replace(/\[Project.CustomFieldValue27_PostalCode\]/g, this.options.tokens.project.customFieldValue27_PostalCode);
		input = input.replace(/\[Project.CustomFieldValue27_Country\]/g, this.options.tokens.project.customFieldValue27_Country);
		input = input.replace(/\[Project.CustomFieldValue27_Phone\]/g, this.options.tokens.project.customFieldValue27_Phone);
		input = input.replace(/\[Project.CustomFieldValue27_Fax\]/g, this.options.tokens.project.customFieldValue27_Fax);
		input = input.replace(/\[Project.CustomFieldValue27_Cell\]/g, this.options.tokens.project.customFieldValue27_Cell);
		input = input.replace(/\[Project.CustomFieldValue27_Email\]/g, this.options.tokens.project.customFieldValue27_Email);

		input = input.replace(/\[Project.CustomFieldValue1_CLBR\]/g, this.options.tokens.project.customFieldValue1_CLBR);
		input = input.replace(/\[Project.CustomFieldValue2_CLBR\]/g, this.options.tokens.project.customFieldValue2_CLBR);
		input = input.replace(/\[Project.CustomFieldValue3_CLBR\]/g, this.options.tokens.project.customFieldValue3_CLBR);
		input = input.replace(/\[Project.CustomFieldValue4_CLBR\]/g, this.options.tokens.project.customFieldValue4_CLBR);
		input = input.replace(/\[Project.CustomFieldValue5_CLBR\]/g, this.options.tokens.project.customFieldValue5_CLBR);
		input = input.replace(/\[Project.CustomFieldValue6_CLBR\]/g, this.options.tokens.project.customFieldValue6_CLBR);
		input = input.replace(/\[Project.CustomFieldValue7_CLBR\]/g, this.options.tokens.project.customFieldValue7_CLBR);
		input = input.replace(/\[Project.CustomFieldValue8_CLBR\]/g, this.options.tokens.project.customFieldValue8_CLBR);
		input = input.replace(/\[Project.CustomFieldValue9_CLBR\]/g, this.options.tokens.project.customFieldValue9_CLBR);
		input = input.replace(/\[Project.CustomFieldValue10_CLBR\]/g, this.options.tokens.project.customFieldValue10_CLBR);
		input = input.replace(/\[Project.CustomFieldValue11_CLBR\]/g, this.options.tokens.project.customFieldValue11_CLBR);
		input = input.replace(/\[Project.CustomFieldValue12_CLBR\]/g, this.options.tokens.project.customFieldValue12_CLBR);
		input = input.replace(/\[Project.CustomFieldValue13_CLBR\]/g, this.options.tokens.project.customFieldValue13_CLBR);
		input = input.replace(/\[Project.CustomFieldValue14_CLBR\]/g, this.options.tokens.project.customFieldValue14_CLBR);
		input = input.replace(/\[Project.CustomFieldValue15_CLBR\]/g, this.options.tokens.project.customFieldValue15_CLBR);
		input = input.replace(/\[Project.CustomFieldValue16_CLBR\]/g, this.options.tokens.project.customFieldValue16_CLBR);
		input = input.replace(/\[Project.CustomFieldValue17_CLBR\]/g, this.options.tokens.project.customFieldValue17_CLBR);
		input = input.replace(/\[Project.CustomFieldValue18_CLBR\]/g, this.options.tokens.project.customFieldValue18_CLBR);
		input = input.replace(/\[Project.CustomFieldValue19_CLBR\]/g, this.options.tokens.project.customFieldValue19_CLBR);
		input = input.replace(/\[Project.CustomFieldValue20_CLBR\]/g, this.options.tokens.project.customFieldValue20_CLBR);
		input = input.replace(/\[Project.CustomFieldValue21_CLBR\]/g, this.options.tokens.project.customFieldValue21_CLBR);
		input = input.replace(/\[Project.CustomFieldValue22_CLBR\]/g, this.options.tokens.project.customFieldValue22_CLBR);
		input = input.replace(/\[Project.CustomFieldValue23_CLBR\]/g, this.options.tokens.project.customFieldValue23_CLBR);
		input = input.replace(/\[Project.CustomFieldValue24_CLBR\]/g, this.options.tokens.project.customFieldValue24_CLBR);
		input = input.replace(/\[Project.CustomFieldValue25_CLBR\]/g, this.options.tokens.project.customFieldValue25_CLBR);
		input = input.replace(/\[Project.CustomFieldValue26_CLBR\]/g, this.options.tokens.project.customFieldValue26_CLBR);
		input = input.replace(/\[Project.CustomFieldValue27_CLBR\]/g, this.options.tokens.project.customFieldValue27_CLBR);
		input = input.replace(/\[Project.CustomFieldValue28_CLBR\]/g, this.options.tokens.project.customFieldValue28_CLBR);
		input = input.replace(/\[Project.CustomFieldValue29_CLBR\]/g, this.options.tokens.project.customFieldValue29_CLBR);
		input = input.replace(/\[Project.CustomFieldValue30_CLBR\]/g, this.options.tokens.project.customFieldValue30_CLBR);
		input = input.replace(/\[Project.CustomFieldValue31_CLBR\]/g, this.options.tokens.project.customFieldValue31_CLBR);
		input = input.replace(/\[Project.CustomFieldValue32_CLBR\]/g, this.options.tokens.project.customFieldValue32_CLBR);
		input = input.replace(/\[Project.CustomFieldValue33_CLBR\]/g, this.options.tokens.project.customFieldValue33_CLBR);
		input = input.replace(/\[Project.CustomFieldValue34_CLBR\]/g, this.options.tokens.project.customFieldValue34_CLBR);
		input = input.replace(/\[Project.CustomFieldValue35_CLBR\]/g, this.options.tokens.project.customFieldValue35_CLBR);
		input = input.replace(/\[Project.CustomFieldValue36_CLBR\]/g, this.options.tokens.project.customFieldValue36_CLBR);
		input = input.replace(/\[Project.CustomFieldValue37_CLBR\]/g, this.options.tokens.project.customFieldValue37_CLBR);
		input = input.replace(/\[Project.CustomFieldValue38_CLBR\]/g, this.options.tokens.project.customFieldValue38_CLBR);
		input = input.replace(/\[Project.CustomFieldValue39_CLBR\]/g, this.options.tokens.project.customFieldValue39_CLBR);

		input = input.replace(/\[BidForms.GroupDueDates\]/g, this.options.tokens.bidForms.groupDueDates);

		input = input.replace(/\[ProjectContacts.UserType395_CompanyName\]/g, this.options.tokens.projectContacts.userType395_CompanyName);
		input = input.replace(/\[ProjectContacts.UserType395_ContactName\]/g, this.options.tokens.projectContacts.userType395_ContactName);
		input = input.replace(/\[ProjectContacts.UserType395_ContactTitle\]/g, this.options.tokens.projectContacts.userType395_ContactTitle);
		input = input.replace(/\[ProjectContacts.UserType395_Address26\]/g, this.options.tokens.projectContacts.userType395_Address);
		input = input.replace(/\[ProjectContacts.UserType395_Address2\]/g, this.options.tokens.projectContacts.userType395_Address2);
		input = input.replace(/\[ProjectContacts.UserType395_City\]/g, this.options.tokens.projectContacts.userType395_City);
		input = input.replace(/\[ProjectContacts.UserType395_StateProvince\]/g, this.options.tokens.projectContacts.userType395_StateProvince);
		input = input.replace(/\[ProjectContacts.UserType395_PostalCode\]/g, this.options.tokens.projectContacts.userType395_PostalCode);
		input = input.replace(/\[ProjectContacts.UserType395_Country\]/g, this.options.tokens.projectContacts.userType395_Country);
		input = input.replace(/\[ProjectContacts.UserType395_Phone\]/g, this.options.tokens.projectContacts.userType395_Phone);
		input = input.replace(/\[ProjectContacts.UserType395_Fax\]/g, this.options.tokens.projectContacts.userType395_Fax);
		input = input.replace(/\[ProjectContacts.UserType395_Cell\]/g, this.options.tokens.projectContacts.userType395_Cell);
		input = input.replace(/\[ProjectContacts.UserType395_Email\]/g, this.options.tokens.projectContacts.userType395_Email);

		input = input.replace(/\[ProjectContacts.UserType396_CompanyName\]/g, this.options.tokens.projectContacts.userType396_CompanyName);
		input = input.replace(/\[ProjectContacts.UserType396_ContactName\]/g, this.options.tokens.projectContacts.userType396_ContactName);
		input = input.replace(/\[ProjectContacts.UserType396_ContactTitle\]/g, this.options.tokens.projectContacts.userType396_ContactTitle);
		input = input.replace(/\[ProjectContacts.UserType396_Address26\]/g, this.options.tokens.projectContacts.userType396_Address);
		input = input.replace(/\[ProjectContacts.UserType396_Address2\]/g, this.options.tokens.projectContacts.userType396_Address2);
		input = input.replace(/\[ProjectContacts.UserType396_City\]/g, this.options.tokens.projectContacts.userType396_City);
		input = input.replace(/\[ProjectContacts.UserType396_StateProvince\]/g, this.options.tokens.projectContacts.userType396_StateProvince);
		input = input.replace(/\[ProjectContacts.UserType396_PostalCode\]/g, this.options.tokens.projectContacts.userType396_PostalCode);
		input = input.replace(/\[ProjectContacts.UserType396_Country\]/g, this.options.tokens.projectContacts.userType396_Country);
		input = input.replace(/\[ProjectContacts.UserType396_Phone\]/g, this.options.tokens.projectContacts.userType396_Phone);
		input = input.replace(/\[ProjectContacts.UserType396_Fax\]/g, this.options.tokens.projectContacts.userType396_Fax);
		input = input.replace(/\[ProjectContacts.UserType396_Cell\]/g, this.options.tokens.projectContacts.userType396_Cell);
		input = input.replace(/\[ProjectContacts.UserType396_Email\]/g, this.options.tokens.projectContacts.userType396_Email);

		return input;
	}
});

PJQ.views.projectInvites.ProjectInviteModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Project-Invite'),
		minWidth: '90%',
		onSend: _.noop,
		onCancel: _.noop,
		onAddFromThisProject: _.noop,
		onViewSelected: _.noop,
		projectMessagingView: null,
		project: null,
		emailTemplates: [],
		isShowQuickAdd: false,
		isShowAttachments: false,
		isShowAddParticipants: false
	},
	events: {
		'click .preview-invite': 'previewInvite',
		'click .invite-send': 'sendInvite',
		'click .invite-preview': 'previewInvite',
		'click .invite-close': 'closeInvite',
		'click .btn-add-participants-from-project': 'addParticipantsFromProject',
		'click .btn-add-participants-from-this-project': 'addParticipantsFromThisProject',
		'click .btn-detailed-search': 'detailedSearch',
		'click .btn-detailed-search-new': 'detailedSearch',
		'click .btn-simple-search': 'simpleSearch',
		'click .btn-quick-search': 'quickSearch',
		'click .view-selected-contacts': 'viewSelected',
		'click .preview-export': 'export'
	},
	beforeRender: function () {
		this.renderData = {};
	},
	afterRender: function () {
		this.$('.count-selected-contacts').html(_.size(this.options.projectMessagingView.options.selectedContacts));
		this.projectInvite = new PJQ.views.projectInvites.ProjectInvite({
			el: this.$('.project-invite'),
			project: this.options.project,
			emailTemplates: this.options.emailTemplates,
			replyToContacts: this.options.replyToContacts,
			defaultTemplateKey: this.options.defaultTemplateKey,
			onChange: _.bind(function () {
				this.$('.invite-send').prop('disabled', (_.size(this.options.project.inviteSettings.messageSubject) === 0 ||
					_.size(this.options.project.inviteSettings.messageBody) === 0 ||
					(_.size(this.options.projectMessagingView.options.selectedContacts) === 0 &&
						!PJQ.helpers.validators.validateEmail(this.options.project.inviteSettings.quickAdd, true).success)
				));

			}, this),
			isShowQuickAdd: this.options.isShowQuickAdd,
			isShowAttachments: this.options.isShowAttachments
		});
	},
	previewInvite: function () {
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.get('projectId')
			},
			{
				endpoint: 'projectmessagepreview'
			}
		], [
			{
				parameter: "templateKey",
				value: this.options.project.inviteSettings.emailTemplate.get('templateKey')
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint
		}).post().done(_.bind(function (data) {
			new PJQ.views.projectInvites.ProjectInvitePreviewModal({
				tokens: data,
				inviteSettings: this.options.project.inviteSettings,
				project: this.options.project
			});
		}, this)).fail(function () {
		});

	},
	export: function () {
		let responseType = 'N/A';
		if (this.options.project.inviteSettings.responseType === 'PROJECT')
			responseType = 'ACCEPT/DECLINE';
		else if (this.options.project.inviteSettings.responseType === 'MESSAGE')
			responseType = 'YES/NO';

		this.$('.preview-export').prop('disabled', true);

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.project.get('projectId')
				},
				{
					endpoint: 'projectmessagepreview'
				},
				{
					endpoint: 'export'
				}
			]),
			data: {
				templateKey: this.options.project.inviteSettings.emailTemplate.get('templateKey'),
				responseType: encodeURIComponent(responseType),
				bidDueDate: this.options.project.inviteSettings.responseDue,
				responseDueDate: this.options.project.inviteSettings.responseDue,
				messageSubject: encodeURIComponent(this.projectInvite.translateTokens(this.options.project.inviteSettings.messageSubject)),
				messageBody: encodeURIComponent(this.projectInvite.translateTokens(this.options.project.inviteSettings.messageBody))
			}
		}).post().success(_.bind(function (data) {
			this.$('.preview-export').prop('disabled', false);
			PJQ.files.downloadFile(data.url, {isEndpoint: false});
		}, this));
	},
	closeInvite: function () {
		if (typeof this.options.onCancel === 'function')
			this.options.onCancel();

		this.removeModal();
	},
	sendInvite: function () {
		let button = this.$('.invite-send');
		button.attr('disabled', true);
		if (this.options.project.inviteSettings.attachments && _.size(this.options.project.inviteSettings.attachments.models) > 0) {
			// enforce max file size of 15728640
			let totalSize = 0;
			_.each(this.options.project.inviteSettings.attachments.models, _.bind(function (fileModel) {
				totalSize += fileModel.file ? fileModel.file.size : fileModel.get('size');
			}, this));

			if (totalSize > 15728640) {
				PJQ.notifications.notify.warningNotify({
					message: 'The total size of uploaded attachments exceeds the 15mb limit.'
				});
				button.attr('disabled', false);
				return;
			}
		}
		// Remove no-space replacement characters
		this.options.project.inviteSettings.messageBody = this.options.project.inviteSettings.messageBody.replace(/[\u200B-\u200D\uFEFF]/g, '');

		let sendOptions = [{
			projectId: this.options.project.get('projectId'),
			messageSubject: this.options.project.inviteSettings.messageSubject,
			messageBody: this.options.project.inviteSettings.messageBody,
			responseType: this.options.project.inviteSettings.responseType,
			templateKey: this.options.project.inviteSettings.messageType,
			responseDue: this.options.project.inviteSettings.responseDue,
			sendEmail: true,
			sendFax: this.options.project.inviteSettings.sendFaxAlways,
			sendFaxIfNoEmail: this.options.project.inviteSettings.sendFaxIfNoEmail,
			sendFaxIfEmailFails: this.options.project.inviteSettings.sendFaxIfEmailFails,
			quickAdd: this.options.project.inviteSettings.quickAdd,
			attachments: this.options.project.inviteSettings.attachments.models,
			privateFolders: this.options.project.inviteSettings.privateFolders.models,
			replyTo: this.options.project.inviteSettings.replyTo
		}];

		let endpointCheck = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects'
			},
			{
				endpoint: 'sendprojectmessages'
			},
			{
				endpoint: 'checkrecipients'
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpointCheck,
			data: {
				isAddAllGroups: false,
				contacts: this.options.projectMessagingView.options.selectedContacts,
				projectMessageSendOptions: sendOptions
			},
			isApi2: true
		}).post().done(_.bind(function (data) {

			let sendCallback = _.bind(function () {
				let endpointSend = PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects'
					},
					{
						endpoint: 'sendprojectmessages'
					}
				]);
				new PJQ.ajax.Request({
					endpoint: endpointSend,
					data: {
						isAddAllGroups: false,
						contacts: this.options.projectMessagingView.options.selectedContacts,
						projectMessageSendOptions: sendOptions
					},
					isApi2: true
				}).post().done(_.bind(function (data) {
					if (typeof this.options.onSend === 'function')
						this.options.onSend();

					this.options.project.inviteSettings = null;

					PJQ.notifications.notify.successNotify({
						message: 'Message queued for sending'
					});

					this.removeModal();

				}, this)).fail(function () {
					PJQ.notifications.notify.errorNotify({
						message: 'Something went wrong.'
					});
					button.attr('disabled', false);
				});
			}, this);

			if (data.nonPendingCount > 0) {
				new PJQ.views.modals.YesNo({
					header: "Project Status Warning",
					body: "Participants in your selection have a non-PENDING status.  If you send this message, it will reset their status back to PENDING.  Do you want to continue?",
					onYes: _.bind(function () {
						sendCallback();
					}, this)
				});
			}
			else
				sendCallback();


		}, this)).fail(function () {
			button.attr('disabled', false);
			PJQ.notifications.notify.errorNotify({
				message: 'Something went wrong.'
			});
		});


	},
	addSelectedContacts: function (selectedContacts) {
		this.options.projectMessagingView.addSelectedContacts(selectedContacts);
		this.$('.count-selected-contacts').html(this.options.projectMessagingView.options.selectedContacts.length);
		this.options.projectMessagingView.stats.unsentCount += _.size(selectedContacts);
		this.options.projectMessagingView.renderContactStats();
		this.options.projectMessagingView.renderView();
		this.$('.invite-send').prop('disabled', this.options.projectMessagingView.options.selectedContacts.length === 0);
	},
	addParticipantsFromThisProject: function () {
		this.options.onAddFromThisProject(this.options.project.inviteSettings);
		this.removeModal();
	},
	addParticipantsFromProject: function () {
		let statuses = this.options.project.getProjectStatusList();
		new PJQ.views.projectParticipants.AddParticipantsFromProjectModal({
			model: this.options.project,
			isBidFormsEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS),
			projectResponses: statuses,
			isReturnContactIds: true,
			onSave: _.bind(function (selectedContacts) {
				this.addSelectedContacts(selectedContacts);
			}, this)
		});
	},
	simpleSearch: function () {
		let showUnionStatus = true;
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS)) {
			showUnionStatus = !PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS);
		}
		new PJQ.views.projectParticipants.AddParticipantsModal({
			model: this.options.project,
			isDirectoryEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY),
			isUnionStatusEnabled: showUnionStatus,
			isReturnContactIds: true,
			onSave: _.bind(function (selectedContacts) {
				this.addSelectedContacts(selectedContacts);
			}, this)
		});
	},
	quickSearch: function () {
		new PJQ.views.contacts.SelectContactsModal({
			isSingleChoice: false,
			onSave: _.bind(function (selectedContacts) {
				this.options.project.addParticipantsById(selectedContacts, _.bind(function () {
					this.addSelectedContacts(_.map(selectedContacts, function (selectedContact) {
						return selectedContact.get('contactId');
					}));
				}, this));
			}, this)
		});
	},
	detailedSearch: function (e) {
		$('form[name="modal-add-participants"]').remove();
		let options = {
			onSave: _.bind(function (selectedContacts) {
				this.addSelectedContacts(selectedContacts);
			}, this)
		};

		if ($(e.currentTarget).hasClass('btn-detailed-search-new') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK)) {
			options.isWrapForm = false;
			options.wrapFormName = null;
			options.isUseNewAddressBook = true;
		}

		new PJQ.views.projects.AddParticipantsDetailedModal(options);
	},
	viewSelected: function () {
		if (_.size(this.options.projectMessagingView.options.selectedContacts) > 0) {
			this.options.onViewSelected();
			this.removeModal();
		}
	}
});

PJQ.views.projectInvites.ProjectInvitesModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Project-Invites'),
		minWidth: '60%',
		onSend: _.noop,
		onClose: _.noop,
		projects: [],
		emailTemplates: []
	},
	events: {
		'click .project-invites-add-contacts': 'addContacts',
		'click .btn-remove-contact': 'removeContact',
		'click .project-invites-jump-step': 'jumpStep',
		'click .preview-invite': 'previewInvite',
		'click .remove-invite': 'removeInvite',
		'click .invites-close': 'onClose',
		'click .invites-send': 'onSend',
		'click .btn-detailed-search-new': 'detailedSearch',
	},
	beforeModalCreated: function () {
		this.contacts = [];
		this.selectedContacts = [];
		this.selectedCompanies = [];
		this.selectedGroups = [];
	},
	beforeRender: function () {
		this.renderData = {
			projects: this.options.projects,
			emailTemplates: this.options.emailTemplates,
			responseDueLabel: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.MESSAGE_RESPONSE_DUE_LABEL) : "Response Due"
		};
	},
	afterRender: function () {
		this.contactTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.contact-list'),
			data: [],
			isHideSearch: true,
			order: [],
			columns: [
				{"data": "attributes.companyName", "title": "Company Name", "orderable": false},
				{"data": "attributes.contactName", "title": "Contact Name", "orderable": false},
				{"data": "attributes.phone", "title": "Phone", "orderable": false},
				{"data": "attributes.email", "title": "Email", "orderable": false},
				{
					"title": '',
					"render": function () {
						return '<button type="button" class="btn btn-danger btn-remove-contact ml-2" title="Remove Contact"><i class="fal fa-trash"></i></button>';
					},
					"width": "120px",
					"orderable": false,
					"searchable": false,
					"className": "text-center",
					"visible": true
				}
			],
			dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
			language: {
				"emptyTable": "No contacts have been selected"
			}
		});
		$('#project-invite-step-2').on('shown.bs.collapse', _.bind(function () {
			this.manageButtonStates(_.size(this.contactTable.dataTable.data()));
			if (this.step === 2 && this.$('#projectInvitesAccordion div.collapse.show').length === 0) {
				this.$('#project-accordion-' + this.options.projects[0].get('projectId')).collapse('show');
			}
		}, this));

		$('div.collapse.project-accordion-step').on('shown.bs.collapse', _.bind(function (e) {
			let projectId = parseInt($(e.currentTarget).data('projectId')),
				project = _.filter(this.options.projects, _.bind(function (project, index) {
					return projectId === project.get('projectId');
				}, this))[0];

			if (!project.inviteSettings.isShown) {
				project.inviteSettings.isShown = true;

				// todo: initialize all other controls here since they don't seem to be working from the other place.

				if (project.get('rDueText') === 'ASAP') {
					project.inviteSettings.responseDueAsapCheckbox.prop('checked', true);
					project.inviteSettings.responseDueInput.val('').prop('disabled', true);
				}
				else if (_.size(project.get('rDueText')) > 0) {
					project.inviteSettings.responseDueInput.val(PJQ.helpers.dateHelpers.getDateString(PJQ.helpers.dateHelpers.parseDateString(project.get('rDueText'), false), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD));
				}

				this.messageTypeSelected(project.get('projectId'), this.options.emailTemplates[0].get('templateKey'));
			}
		}, this));

		_.each(this.options.projects, _.bind(function (project) {
			project.inviteSettings = {};
			project.inviteSettings.isShown = false;
			project.inviteSettings.messageSubject = this.options.emailTemplates[0].get('subjectTemplate');
			project.inviteSettings.messageType = this.options.emailTemplates[0].get('templateKey');
			project.inviteSettings.responseType = this.options.emailTemplates[0].get('projectMessageType');
			project.inviteSettings.sendOptions = {};
			project.inviteSettings.sendOptions.sendEmail = true;
			project.inviteSettings.sendOptions.sendFaxIfNoEmail = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL);
			project.inviteSettings.sendOptions.sendFaxIfEmailFails = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED);
			project.inviteSettings.sendOptions.sendFaxAlways = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS);
			project.inviteSettings.messageBody = this.options.emailTemplates[0].get('defaultTextTemplate');
			project.inviteSettings.responseDue = (project.get('rDueText') === 'ASAP') ? 'ASAP' : project.get('rDueText');

			project.inviteSettings.messageSubjectInput = this.$('#project-accordion-' + project.get('projectId') + ' input.message-subject');
			project.inviteSettings.messageSubjectInput.on('change', _.bind(function () {
				project.inviteSettings.messageSubject = project.inviteSettings.messageSubjectInput.val();
			}, this));
			project.inviteSettings.responseDueInput = this.$('#project-accordion-' + project.get('projectId') + ' input.response-due');
			project.inviteSettings.responseDueInput.on('change', _.bind(function () {
				project.inviteSettings.responseDue = project.inviteSettings.responseDueAsapCheckbox.prop('checked') ? 'ASAP' : project.inviteSettings.responseDueInput.val();
			}, this));
			project.inviteSettings.responseDueAsapCheckbox = this.$('#project-accordion-' + project.get('projectId') + ' input.response-due-asap');
			project.inviteSettings.responseDueAsapCheckbox.on('click', _.bind(function () {
				project.inviteSettings.responseDue = project.inviteSettings.responseDueAsapCheckbox.prop('checked') ? 'ASAP' : project.inviteSettings.responseDueInput.val();
				project.inviteSettings.responseDueInput.val('').prop('disabled', project.inviteSettings.responseDueAsapCheckbox.prop('checked'));
			}, this));

			project.inviteSettings.messageTypeSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('#project-accordion-' + project.get('projectId') + ' select.message-type'),
				dropupAuto: false,
				onChange: _.bind(function () {
					this.messageTypeSelected(project.get('projectId'), project.inviteSettings.messageTypeSelectPicker.getValue());
				}, this)
			});

			project.inviteSettings.responseTypeSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('#project-accordion-' + project.get('projectId') + ' select.response-type'),
				onChange: _.bind(function (value) {
					project.inviteSettings.responseType = value;
				}, this),
			});

			let defaultSendOptions = ["1"];
			if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_FAX)) {
				this.$('#project-accordion-' + project.get('projectId') + ' select.send-options option[value="2"]').prop('hidden', true);
				this.$('#project-accordion-' + project.get('projectId') + ' select.send-options option[value="3"]').prop('hidden', true);
				this.$('#project-accordion-' + project.get('projectId') + ' select.send-options option[value="4"]').prop('hidden', true);
			}
			else {
				if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL)) {
					this.$('#project-accordion-' + project.get('projectId') + ' select.send-options option[value="2"]').prop('selected', true);
					defaultSendOptions.push("2");
				}

				if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED)) {
					this.$('#project-accordion-' + project.get('projectId') + ' select.send-options option[value="3"]').prop('selected', true);
					defaultSendOptions.push("3");
				}

				if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS)) {
					this.$('#project-accordion-' + project.get('projectId') + ' select.send-options option[value="4"]').prop('selected', true);
					defaultSendOptions.push("4");
				}
			}

			project.inviteSettings.sendOptionsSelectPicker = new PJQ.inputs.SelectpickerProjectMessageSendOptions({
				el: this.$('#project-accordion-' + project.get('projectId') + ' select.send-options'),
				onChange: _.bind(function (value) {
					project.inviteSettings.sendFaxIfNoEmail = value.indexOf("2") !== -1;
					project.inviteSettings.sendFaxIfEmailFails = value.indexOf("3") !== -1;
					project.inviteSettings.sendFaxAlways = value.indexOf("4") !== -1;
				}, this),
				isMultiple: true,
				isIntChoices: false,
				hideDisabled: false,
				noneSelectedText: 'No Options Selected',
				defaultValue: ["1"],
				exclusiveChoices: ["4"]
			});

			project.inviteSettings.messageBodyHTMLEditor = new PJQ.inputs.HTMLEditor({
				el: this.$('#project-accordion-' + project.get('projectId') + ' div.invite-message'),
				onInit: _.bind(function () {
					let tokenBtn = '<button type="button" class="btn btn-default btn-sm btn-small tokenBtn" title="Token List" data-event="something" tabindex="-1">Tokens</button>',
						tokenGroup = '<div class="note-file btn-group">' + tokenBtn + '</div>';

					$(tokenGroup).prependTo(this.$('.note-toolbar'));
					this.$('.tokenBtn').tooltip({container: 'body', placement: 'bottom'});
					this.$('.tokenBtn').click(function (event) {
						// load token dialog
					});

				}, this),
				onChange: _.bind(function (contents) {
					project.inviteSettings.messageBody = contents;
				}, this),
				defaultValue: this.options.emailTemplates[0].get('defaultTextTemplate')
			});
		}, this));

		this.$('.project-invites-selected-project-count').text(_.size(this.options.projects));
		this.manageButtonStates(0);
		this.goToStep(1);
	},
	onClose: function () {
		if (typeof this.options.onClose === 'function')
			this.options.onClose();
		this.removeModal();
	},
	detailedSearch: function (e) {
		$('form[name="modal-add-participants"]').remove();
		let options = {
			onSave: _.bind(function (selectedContactsAll, data) {
				this.selectedContacts = _.union(this.selectedContacts, data.selectedContacts);
				this.selectedCompanies = _.union(this.selectedCompanies, data.selectedCompanies);
				this.selectedGroups = _.union(this.selectedGroups, data.selectedGroups);

				if (_.size(selectedContactsAll) > 0) {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'contacts'
							},
							{
								endpoint: 'list'
							},
						], [{
							parameter: 'contactIds',
							value: selectedContactsAll
						}
						])
					}).get().done(_.bind(function (data) {
						if (_.size(data) > 0) {
							_.each(data, function (model) {
								this.contacts.push(new PJQ.models.contacts.Contact(model))
							}, this)
							this.contactTable.resetData(this.contacts);
							this.contactTable.dataTable.draw();
							this.manageButtonStates(_.size(this.contactTable.dataTable.data()));
						}
					}, this)).fail(function (xhr, err, result) {

					});
				}
			}, this),
			disableContacts: _.map(this.contactTable.dataTable.data(), function (row) {
				return row.attributes.contactId;
			})
		};

		if ($(e.currentTarget).hasClass('btn-detailed-search-new') && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK)) {
			options.isWrapForm = false;
			options.wrapFormName = null;
			options.isUseNewAddressBook = true;
			options.isMultipleProjects = true;
			options.projects = this.options.projects;
		}

		new PJQ.views.projects.AddParticipantsDetailedModal(options);
	},

	onSend: function () {
		let sendOptions = [];
		_.each(this.options.projects, _.bind(function (project) {
			let sendOption = {};
			sendOption.projectId = project.get('projectId');
			sendOption.messageSubject = project.inviteSettings.messageSubject;
			sendOption.messageBody = project.inviteSettings.messageBody;
			sendOption.responseType = project.inviteSettings.responseType;
			sendOption.templateKey = project.inviteSettings.messageType;
			sendOption.responseDue = project.inviteSettings.responseDue;
			sendOption.sendEmail = true;
			sendOption.sendFax = project.inviteSettings.sendFaxAlways;
			sendOption.sendFaxIfNoEmail = project.inviteSettings.sendFaxIfNoEmail;
			sendOption.sendFaxIfEmailFails = project.inviteSettings.sendFaxIfEmailFails;
			sendOptions.push(sendOption);
		}, this));

		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects'
			},
			{
				endpoint: 'sendprojectmessages'
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint,
			data: {
				contacts: _.map(this.contactTable.dataTable.data(), function (contact) {
					return contact.get('contactId')
				}),
				projectMessageSendOptions: sendOptions
			}
		}).post().done(_.bind(function (data) {
			if (typeof this.options.onSend === 'function')
				this.options.onSend();

			new PJQ.views.BaseModal({
				header: "Project Invites Sent",
				body: "Your project invites are now being processed for broadcast.",
				isShowCancelButton: false
			});

			this.removeModal();
		}, this)).fail(function () {

		});

	},
	jumpStep: function (e) {
		let step = parseInt($(e.currentTarget).data('step').toString());
		this.goToStep(step);
	},
	goToStep: function (step) {
		this.step = step;
		let thisStep = $('.step-' + this.step.toString()),
			thisStepHeader = $('.step-header-' + this.step.toString());
		this.$('[class*=step-]').not(thisStep).collapse('hide');
		this.$('[class*=step-header-]').not(thisStepHeader).removeClass('text-primary').addClass('text-dark op-4');
		thisStepHeader.removeClass('text-dark op-4').addClass('text-primary');

		if (this.step === 1) {
			this.$('.project-invites-selected-contact-count').parent().removeClass('text-dark op-4').addClass('text-info');
			this.$('.project-invites-selected-project-count').parent().removeClass('text-info').addClass('text-dark op-4');
		}
		else if (this.step === 2) {
			this.$('.project-invites-selected-contact-count').parent().removeClass('text-info').addClass('text-dark op-4');
			this.$('.project-invites-selected-project-count').parent().removeClass('text-dark op-4').addClass('text-info');
		}

		thisStep.collapse('show');
	},
	addContacts: function () {
		new PJQ.views.contacts.SelectContactsModal({
			context: PJQ.constants.contacts.contexts.CONTACTS,
			isSingleChoice: false,
			subtitle: "Add Contacts to Project Invites",
			disableContacts: _.map(this.contactTable.dataTable.data(), function (row) {
				return {id: row.attributes.contactId};
			}),
			onSave: _.bind(function (selectedContacts) {
				this.contactTable.dataTable.rows.add(selectedContacts);
				this.contactTable.dataTable.draw();
				this.manageButtonStates(_.size(this.contactTable.dataTable.data()));
			}, this)
		});
	},
	removeContact: function (e) {
		let row = this.contactTable.getRow($(e.currentTarget).closest('tr')),
			contact = row.data();

		let deleteText = 'Are you sure you want to remove ' + contact.get('companyName') + ' from the list?';
		if (this.contactTable.dataTable.data().length === 1)
			deleteText += ' This is the last contact in the invite list, and if you remove it it will cancel this process.';

		new PJQ.views.BaseModal({
			header: "Confirm Remove Contact",
			okButtonText: 'Remove',
			body: deleteText,
			isShowCancelButton: true,
			onOk: _.bind(function () {
				row.remove().draw();
				this.manageButtonStates(_.size(this.contactTable.dataTable.data()));
				if (this.contactTable.dataTable.data().length === 0)
					this.onClose();
			}, this)
		});
	},
	manageButtonStates: function (contactCount) {
		this.$('.project-invites-selected-contact-count').text(contactCount);
		this.$('.invites-send').prop('disabled', (contactCount === 0 || this.step === 1));
		this.$('.project-invites-jump-step').prop('disabled', contactCount === 0);
	},
	messageTypeSelected: function (projectId, templateKey) {
		let emailTemplate = _.filter(this.options.emailTemplates, function (template) {
			return template.get('templateKey') === templateKey
		})[0];
		let project = _.filter(this.options.projects, function (project) {
			return project.get('projectId') === projectId
		})[0];
		project.inviteSettings.emailTemplate = emailTemplate;
		project.inviteSettings.messageType = emailTemplate.get('templateKey');
		project.inviteSettings.messageSubject = emailTemplate.get('subjectTemplate');
		project.inviteSettings.messageSubjectInput.val(emailTemplate.get('subjectTemplate'));
		project.inviteSettings.responseTypeSelectPicker.setValue(emailTemplate.get('projectMessageType') ? emailTemplate.get('projectMessageType') : "NONE");
		project.inviteSettings.messageBodyHTMLEditor.setValue(emailTemplate.get('defaultTextTemplate'));
		project.inviteSettings.messageBody = emailTemplate.get('defaultTextTemplate');
	},
	previewInvite: function (e) {
		let projectId = parseInt($(e.currentTarget).closest('div.project-accordion-step').data('projectId')),
			project = _.filter(this.options.projects, _.bind(function (project) {
				return project.get('projectId') === projectId
			}, this))[0];

		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: project.get('projectId')
			},
			{
				endpoint: 'projectmessagepreview'
			}
		], [
			{
				parameter: "templateKey",
				value: project.inviteSettings.emailTemplate.get('templateKey')
			}
		]);
		new PJQ.ajax.Request({
			endpoint: endpoint
		}).post().done(_.bind(function (data) {
			new PJQ.views.projectInvites.ProjectInvitePreviewModal({
				tokens: data,
				inviteSettings: project.inviteSettings,
				project: project
			});
		}, this)).fail(function () {
			PJQ.notifications.notify.errorNotify({
				message: 'Something went wrong.'
			});
		});

	},
	removeInvite: function (e) {
		let projectId = this.$(e.currentTarget).closest('div.project-accordion-step').data('projectId'),
			project = _.filter(this.options.projects, _.bind(function (project) {
				return project.get('projectId') === projectId
			}, this))[0];
		let deleteText = 'Are you sure you want to remove this project from the invite list?';

		if (_.size(this.options.projects) === 1)
			deleteText += ' This is the last project in the invite list, and if you remove it it will cancel this process.';

		new PJQ.views.BaseModal({
			header: "Confirm Remove",
			okButtonText: 'Remove',
			body: deleteText,
			isShowCancelButton: true,
			onOk: _.bind(function () {
				this.options.projects = _.filter(this.options.projects, _.bind(function (project) {
					return project.get('projectId') !== projectId;
				}, this));
				this.$('#project-accordion-' + project.get('projectId')).parent().remove();

				if (_.size(this.options.projects) === 0)
					this.onClose();
				else
					this.$('#project-accordion-' + this.options.projects[0].get('projectId')).collapse('show');

			}, this)
		});
	}
});

PJQ.views.projectInvites.ProjectInvitePreviewModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Project-Invite-Preview'),
		minWidth: '60%',
		tokens: null,
		inviteSettings: null,
		project: null
	},
	events: {
		'click .preview-export': 'export'
	},
	afterRender: function () {
		let subject = this.options.inviteSettings.messageSubject,
			body = this.options.inviteSettings.emailTemplate.get('bodyTemplate');

		this.options.tokens.projectMessage.responseType = 'N/A';
		if (this.options.inviteSettings.responseType === 'PROJECT')
			this.options.tokens.projectMessage.responseType = 'ACCEPT/DECLINE';
		else if (this.options.inviteSettings.responseType === 'MESSAGE')
			this.options.tokens.projectMessage.responseType = 'YES/NO';

		this.options.tokens.projectMessage.bidDueDate = this.options.inviteSettings.responseDue;
		this.options.tokens.projectMessage.responseDueDate = this.options.inviteSettings.responseDue;

		this.options.tokens.projectMessage.messageBody = this.translateTokens(this.options.inviteSettings.messageBody);
		this.$('.message-subject').html(this.translateTokens(subject));
		this.$('.message-body').html(this.translateTokens(body));
	},
	translateTokens: function (input) {
		input = input.replace(/\[Sender.Username\]/g, this.options.tokens.sender.username);
		input = input.replace(/\[Sender.Company\]/g, this.options.tokens.sender.company);
		input = input.replace(/\[Sender.Contact\]/g, this.options.tokens.sender.contact);
		input = input.replace(/\[Sender.Address1\]/g, this.options.tokens.sender.address1);
		input = input.replace(/\[Sender.Address2\]/g, this.options.tokens.sender.address2);
		input = input.replace(/\[Sender.City\]/g, this.options.tokens.sender.city);
		input = input.replace(/\[Sender.State\]/g, this.options.tokens.sender.state);
		input = input.replace(/\[Sender.Zip\]/g, this.options.tokens.sender.zip);
		input = input.replace(/\[Sender.Country\]/g, this.options.tokens.sender.country);
		input = input.replace(/\[Sender.Phone\]/g, this.options.tokens.sender.phone);
		input = input.replace(/\[Sender.PhoneExtension\]/g, this.options.tokens.sender.phoneExtension);
		input = input.replace(/\[Sender.Fax\]/g, this.options.tokens.sender.fax);
		input = input.replace(/\[Sender.Cell\]/g, this.options.tokens.sender.cell);
		input = input.replace(/\[Sender.Email\]/g, this.options.tokens.sender.email);
		input = input.replace(/\[Sender.EmailLogoURL\]/g, this.options.tokens.sender.emailLogoURL);
		input = input.replace(/\[Sender.FullAddress\]/g, this.options.tokens.sender.fullAddress);
		input = input.replace(/\[Sender.Email2\]/g, this.options.tokens.sender.email2);
		input = input.replace(/\[Sender.Signature\]/g, this.options.tokens.sender.signature);
		input = input.replace(/\[Sender.UserType\]/g, this.options.tokens.sender.userType);

		input = input.replace(/\[SenderPM.Username\]/g, this.options.tokens.senderPM.username);
		input = input.replace(/\[SenderPM.Company\]/g, this.options.tokens.senderPM.company);
		input = input.replace(/\[SenderPM.Contact\]/g, this.options.tokens.senderPM.contact);
		input = input.replace(/\[SenderPM.Address1\]/g, this.options.tokens.senderPM.address1);
		input = input.replace(/\[SenderPM.Address2\]/g, this.options.tokens.senderPM.address2);
		input = input.replace(/\[SenderPM.City\]/g, this.options.tokens.senderPM.city);
		input = input.replace(/\[SenderPM.State\]/g, this.options.tokens.senderPM.state);
		input = input.replace(/\[SenderPM.Zip\]/g, this.options.tokens.senderPM.zip);
		input = input.replace(/\[SenderPM.Country\]/g, this.options.tokens.senderPM.country);
		input = input.replace(/\[SenderPM.Phone\]/g, this.options.tokens.senderPM.phone);
		input = input.replace(/\[SenderPM.PhoneExtension\]/g, this.options.tokens.senderPM.phoneExtension);
		input = input.replace(/\[SenderPM.Fax\]/g, this.options.tokens.senderPM.fax);
		input = input.replace(/\[SenderPM.Cell\]/g, this.options.tokens.senderPM.cell);
		input = input.replace(/\[SenderPM.Email\]/g, this.options.tokens.senderPM.email);
		input = input.replace(/\[SenderPM.EmailLogoURL\]/g, this.options.tokens.senderPM.emailLogoURL);
		input = input.replace(/\[SenderPM.FullAddress\]/g, this.options.tokens.senderPM.fullAddress);
		input = input.replace(/\[SenderPM.Email2\]/g, this.options.tokens.senderPM.email2);
		input = input.replace(/\[SenderPM.UserType\]/g, this.options.tokens.senderPM.userType);


		input = input.replace(/\[ProjectContact2.Username\]/g, this.options.tokens.projectContact2.username);
		input = input.replace(/\[ProjectContact2.Company\]/g, this.options.tokens.projectContact2.company);
		input = input.replace(/\[ProjectContact2.Contact\]/g, this.options.tokens.projectContact2.contact);
		input = input.replace(/\[ProjectContact2.Address1\]/g, this.options.tokens.projectContact2.address1);
		input = input.replace(/\[ProjectContact2.Address2\]/g, this.options.tokens.projectContact2.address2);
		input = input.replace(/\[ProjectContact2.City\]/g, this.options.tokens.projectContact2.city);
		input = input.replace(/\[ProjectContact2.State\]/g, this.options.tokens.projectContact2.state);
		input = input.replace(/\[ProjectContact2.Zip\]/g, this.options.tokens.projectContact2.zip);
		input = input.replace(/\[ProjectContact2.Country\]/g, this.options.tokens.projectContact2.country);
		input = input.replace(/\[ProjectContact2.Phone\]/g, this.options.tokens.projectContact2.phone);
		input = input.replace(/\[ProjectContact2.PhoneExtension\]/g, this.options.tokens.projectContact2.phoneExtension);
		input = input.replace(/\[ProjectContact2.Fax\]/g, this.options.tokens.projectContact2.fax);
		input = input.replace(/\[ProjectContact2.Cell\]/g, this.options.tokens.projectContact2.cell);
		input = input.replace(/\[ProjectContact2.Email\]/g, this.options.tokens.projectContact2.email);
		input = input.replace(/\[ProjectContact2.EmailLogoURL\]/g, this.options.tokens.projectContact2.emailLogoURL);
		input = input.replace(/\[ProjectContact2.FullAddress\]/g, this.options.tokens.projectContact2.fullAddress);
		input = input.replace(/\[ProjectContact2.Email2\]/g, this.options.tokens.projectContact2.email2);
		input = input.replace(/\[ProjectContact2.Signature\]/g, this.options.tokens.projectContact2.signature);
		input = input.replace(/\[ProjectContact2.UserType\]/g, this.options.tokens.projectContact2.userType);

		input = input.replace(/\[Recipient.Company\]/g, this.options.tokens.recipient.company);
		input = input.replace(/\[Recipient.Contact\]/g, this.options.tokens.recipient.contact);
		input = input.replace(/\[Recipient.FirstName\]/g, this.options.tokens.recipient.firstName);
		input = input.replace(/\[Recipient.Title\]/g, this.options.tokens.recipient.title);
		input = input.replace(/\[Recipient.Address1\]/g, this.options.tokens.recipient.address1);
		input = input.replace(/\[Recipient.Address2\]/g, this.options.tokens.recipient.address2);
		input = input.replace(/\[Recipient.City\]/g, this.options.tokens.recipient.city);
		input = input.replace(/\[Recipient.State\]/g, this.options.tokens.recipient.state);
		input = input.replace(/\[Recipient.Zip\]/g, this.options.tokens.recipient.zip);
		input = input.replace(/\[Recipient.Country\]/g, this.options.tokens.recipient.country);
		input = input.replace(/\[Recipient.Phone\]/g, this.options.tokens.recipient.phone);
		input = input.replace(/\[Recipient.PhoneExtension\]/g, this.options.tokens.recipient.phoneExtension);
		input = input.replace(/\[Recipient.Fax\]/g, this.options.tokens.recipient.fax);
		input = input.replace(/\[Recipient.Email\]/g, this.options.tokens.recipient.email);
		input = input.replace(/\[Recipient.EmailLogoURL\]/g, this.options.tokens.recipient.emailLogoURL);
		input = input.replace(/\[Recipient.FullAddress\]/g, this.options.tokens.recipient.fullAddress);

		input = input.replace(/\[Portal.URL\]/g, this.options.tokens.portal.url);
		input = input.replace(/\[Portal.Domain\]/g, this.options.tokens.portal.domain);
		input = input.replace(/\[DateTime.Today\]/g, this.options.tokens.dateTime.today);

		input = input.replace(/\[ProjectMessage.AccessKey\]/g, this.options.tokens.projectMessage.accessKey);
		input = input.replace(/\[ProjectMessage.RSVPURL\]/g, this.options.tokens.projectMessage.rsvpurl);
		input = input.replace(/\[ProjectMessage.RecipientGroupList\]/g, this.options.tokens.projectMessage.recipientGroupList);
		input = input.replace(/\[ProjectMessage.RecipientGroupListComma\]/g, this.options.tokens.projectMessage.recipientGroupListComma);
		input = input.replace(/\[ProjectMessage.ResponseDueLabel\]/g, this.options.tokens.projectMessage.responseDueLabel);
		input = input.replace(/\[ProjectMessage.MessageResponseDueLabel\]/g, this.options.tokens.projectMessage.messageResponseDueLabel);
		input = input.replace(/\[ProjectMessage.ResponseDueDate\]/g, this.options.tokens.projectMessage.responseDueDate);
		input = input.replace(/\[ProjectMessage.ResponseDueTime\]/g, this.options.tokens.projectMessage.ResponseDueTime);
		input = input.replace(/\[ProjectMessage.MessageSubject\]/g, this.options.tokens.projectMessage.messageSubject);
		input = input.replace(/\[ProjectMessage.MessageBody\]/g, this.options.tokens.projectMessage.messageBody);
		input = input.replace(/\[ProjectMessage.SentOnDate\]/g, this.options.tokens.projectMessage.sentOnDate);
		input = input.replace(/\[ProjectMessage.EstCompleteDate\]/g, this.options.tokens.projectMessage.estCompleteDate);
		input = input.replace(/\[ProjectMessage.EstStartDate\]/g, this.options.tokens.projectMessage.estStartDate);
		input = input.replace(/\[ProjectMessage.MessageType\]/g, this.options.tokens.projectMessage.messageType);
		input = input.replace(/\[ProjectMessage.ResponseType\]/g, this.options.tokens.projectMessage.responseType);
		input = input.replace(/\[ProjectMessage.MessageName\]/g, this.options.tokens.projectMessage.messageName);

		input = input.replace(/\[Project.ProjectId\]/g, this.options.tokens.project.projectId);
		input = input.replace(/\[Project.Name\]/g, this.options.tokens.project.name);
		input = input.replace(/\[Project.Address1\]/g, this.options.tokens.project.address1);
		input = input.replace(/\[Project.Address2\]/g, this.options.tokens.project.address2);
		input = input.replace(/\[Project.City\]/g, this.options.tokens.project.city);
		input = input.replace(/\[Project.State\]/g, this.options.tokens.project.state);
		input = input.replace(/\[Project.Zip\]/g, this.options.tokens.project.zip);
		input = input.replace(/\[Project.Country\]/g, this.options.tokens.project.country);
		input = input.replace(/\[Project.Notes\]/g, this.options.tokens.project.notes);
		input = input.replace(/\[Project.ResponseDueLabel\]/g, this.options.tokens.project.responseDueLabel);
		input = input.replace(/\[Project.MessageResponseDueLabel\]/g, this.options.tokens.project.messageResponseDueLabel);
		input = input.replace(/\[Project.ResponseDueDate\]/g, this.options.tokens.project.responseDueDate);
		input = input.replace(/\[Project.ResponseDueTime\]/g, this.options.tokens.project.responseDueTime);
		input = input.replace(/\[Project.ResponseDueShortTime\]/g, this.options.tokens.project.responseDueShortTime);
		input = input.replace(/\[Project.ResponseDueTimeZone\]/g, this.options.tokens.project.responseDueTimeZone);
		input = input.replace(/\[Project.ResponseDueDateWithBy\]/g, this.options.tokens.project.responseDueDateWithBy);
		input = input.replace(/\[Project.StartDate\]/g, this.options.tokens.project.startDate);
		input = input.replace(/\[Project.EndDate\]/g, this.options.tokens.project.endDate);
		input = input.replace(/\[Project.ProjectStatus\]/g, this.options.tokens.project.projectStatus);
		input = input.replace(/\[Project.CustomFieldLabel1\]/g, this.options.tokens.project.customFieldLabel1);
		input = input.replace(/\[Project.CustomFieldValue1\]/g, this.options.tokens.project.customFieldValue1);
		input = input.replace(/\[Project.CustomFieldLabel2\]/g, this.options.tokens.project.customFieldLabel2);
		input = input.replace(/\[Project.CustomFieldValue2\]/g, this.options.tokens.project.customFieldValue2);
		input = input.replace(/\[Project.CustomFieldLabel3\]/g, this.options.tokens.project.customFieldLabel3);
		input = input.replace(/\[Project.CustomFieldValue3\]/g, this.options.tokens.project.customFieldValue3);
		input = input.replace(/\[Project.CustomFieldLabel4\]/g, this.options.tokens.project.customFieldLabel4);
		input = input.replace(/\[Project.CustomFieldValue4\]/g, this.options.tokens.project.customFieldValue4);
		input = input.replace(/\[Project.CustomFieldLabel5\]/g, this.options.tokens.project.customFieldLabel5);
		input = input.replace(/\[Project.CustomFieldValue5\]/g, this.options.tokens.project.customFieldValue5);
		input = input.replace(/\[Project.CustomFieldLabel6\]/g, this.options.tokens.project.customFieldLabel6);
		input = input.replace(/\[Project.CustomFieldValue6\]/g, this.options.tokens.project.customFieldValue6);
		input = input.replace(/\[Project.CustomFieldLabel7\]/g, this.options.tokens.project.customFieldLabel7);
		input = input.replace(/\[Project.CustomFieldValue7\]/g, this.options.tokens.project.customFieldValue7);
		input = input.replace(/\[Project.CustomFieldLabel8\]/g, this.options.tokens.project.customFieldLabel8);
		input = input.replace(/\[Project.CustomFieldValue8\]/g, this.options.tokens.project.customFieldValue8);
		input = input.replace(/\[Project.CustomFieldLabel9\]/g, this.options.tokens.project.customFieldLabel9);
		input = input.replace(/\[Project.CustomFieldValue9\]/g, this.options.tokens.project.customFieldValue9);
		input = input.replace(/\[Project.CustomFieldLabel10\]/g, this.options.tokens.project.customFieldLabel10);
		input = input.replace(/\[Project.CustomFieldValue10\]/g, this.options.tokens.project.customFieldValue10);
		input = input.replace(/\[Project.CustomFieldLabel11\]/g, this.options.tokens.project.customFieldLabel11);
		input = input.replace(/\[Project.CustomFieldValue11\]/g, this.options.tokens.project.customFieldValue11);
		input = input.replace(/\[Project.CustomFieldLabel12\]/g, this.options.tokens.project.customFieldLabel12);
		input = input.replace(/\[Project.CustomFieldValue12\]/g, this.options.tokens.project.customFieldValue12);
		input = input.replace(/\[Project.CustomFieldLabel13\]/g, this.options.tokens.project.customFieldLabel13);
		input = input.replace(/\[Project.CustomFieldValue13\]/g, this.options.tokens.project.customFieldValue13);
		input = input.replace(/\[Project.CustomFieldLabel14\]/g, this.options.tokens.project.customFieldLabel14);
		input = input.replace(/\[Project.CustomFieldValue14\]/g, this.options.tokens.project.customFieldValue14);
		input = input.replace(/\[Project.CustomFieldLabel15\]/g, this.options.tokens.project.customFieldLabel15);
		input = input.replace(/\[Project.CustomFieldValue15\]/g, this.options.tokens.project.customFieldValue15);
		input = input.replace(/\[Project.CustomFieldLabel16\]/g, this.options.tokens.project.customFieldLabel16);
		input = input.replace(/\[Project.CustomFieldValue16\]/g, this.options.tokens.project.customFieldValue16);
		input = input.replace(/\[Project.CustomFieldLabel17\]/g, this.options.tokens.project.customFieldLabel17);
		input = input.replace(/\[Project.CustomFieldValue17\]/g, this.options.tokens.project.customFieldValue17);
		input = input.replace(/\[Project.CustomFieldLabel18\]/g, this.options.tokens.project.customFieldLabel18);
		input = input.replace(/\[Project.CustomFieldValue18\]/g, this.options.tokens.project.customFieldValue18);
		input = input.replace(/\[Project.CustomFieldLabel19\]/g, this.options.tokens.project.customFieldLabel19);
		input = input.replace(/\[Project.CustomFieldValue19\]/g, this.options.tokens.project.customFieldValue19);
		input = input.replace(/\[Project.CustomFieldLabel20\]/g, this.options.tokens.project.customFieldLabel20);
		input = input.replace(/\[Project.CustomFieldValue20\]/g, this.options.tokens.project.customFieldValue20);
		input = input.replace(/\[Project.CustomFieldLabel21\]/g, this.options.tokens.project.customFieldLabel21);
		input = input.replace(/\[Project.CustomFieldValue21\]/g, this.options.tokens.project.customFieldValue21);
		input = input.replace(/\[Project.CustomFieldLabel22\]/g, this.options.tokens.project.customFieldLabel22);
		input = input.replace(/\[Project.CustomFieldValue22\]/g, this.options.tokens.project.customFieldValue22);
		input = input.replace(/\[Project.CustomFieldLabel23\]/g, this.options.tokens.project.customFieldLabel23);
		input = input.replace(/\[Project.CustomFieldValue23\]/g, this.options.tokens.project.customFieldValue23);
		input = input.replace(/\[Project.CustomFieldLabel24\]/g, this.options.tokens.project.customFieldLabel24);
		input = input.replace(/\[Project.CustomFieldValue24\]/g, this.options.tokens.project.customFieldValue24);
		input = input.replace(/\[Project.CustomFieldLabel25\]/g, this.options.tokens.project.customFieldLabel25);
		input = input.replace(/\[Project.CustomFieldValue25\]/g, this.options.tokens.project.customFieldValue25);
		input = input.replace(/\[Project.CustomFieldLabel26\]/g, this.options.tokens.project.customFieldLabel26);
		input = input.replace(/\[Project.CustomFieldValue26\]/g, this.options.tokens.project.customFieldValue26);
		input = input.replace(/\[Project.CustomFieldLabel27\]/g, this.options.tokens.project.customFieldLabel27);
		input = input.replace(/\[Project.CustomFieldValue27\]/g, this.options.tokens.project.customFieldValue27);
		input = input.replace(/\[Project.CustomFieldLabel28\]/g, this.options.tokens.project.customFieldLabel28);
		input = input.replace(/\[Project.CustomFieldValue28\]/g, this.options.tokens.project.customFieldValue28);
		input = input.replace(/\[Project.CustomFieldLabel29\]/g, this.options.tokens.project.customFieldLabel29);
		input = input.replace(/\[Project.CustomFieldValue29\]/g, this.options.tokens.project.customFieldValue29);
		input = input.replace(/\[Project.CustomFieldLabel30\]/g, this.options.tokens.project.customFieldLabel30);
		input = input.replace(/\[Project.CustomFieldValue30\]/g, this.options.tokens.project.customFieldValue30);
		input = input.replace(/\[Project.CustomFieldLabel31\]/g, this.options.tokens.project.customFieldLabel31);
		input = input.replace(/\[Project.CustomFieldValue31\]/g, this.options.tokens.project.customFieldValue31);
		input = input.replace(/\[Project.CustomFieldLabel32\]/g, this.options.tokens.project.customFieldLabel32);
		input = input.replace(/\[Project.CustomFieldValue32\]/g, this.options.tokens.project.customFieldValue32);
		input = input.replace(/\[Project.CustomFieldLabel33\]/g, this.options.tokens.project.customFieldLabel33);
		input = input.replace(/\[Project.CustomFieldValue33\]/g, this.options.tokens.project.customFieldValue33);
		input = input.replace(/\[Project.CustomFieldLabel34\]/g, this.options.tokens.project.customFieldLabel34);
		input = input.replace(/\[Project.CustomFieldValue34\]/g, this.options.tokens.project.customFieldValue34);
		input = input.replace(/\[Project.CustomFieldLabel35\]/g, this.options.tokens.project.customFieldLabel35);
		input = input.replace(/\[Project.CustomFieldValue35\]/g, this.options.tokens.project.customFieldValue35);
		input = input.replace(/\[Project.CustomFieldLabel36\]/g, this.options.tokens.project.customFieldLabel36);
		input = input.replace(/\[Project.CustomFieldValue36\]/g, this.options.tokens.project.customFieldValue36);
		input = input.replace(/\[Project.CustomFieldLabel37\]/g, this.options.tokens.project.customFieldLabel37);
		input = input.replace(/\[Project.CustomFieldValue37\]/g, this.options.tokens.project.customFieldValue37);
		input = input.replace(/\[Project.CustomFieldLabel38\]/g, this.options.tokens.project.customFieldLabel38);
		input = input.replace(/\[Project.CustomFieldValue38\]/g, this.options.tokens.project.customFieldValue38);
		input = input.replace(/\[Project.CustomFieldLabel39\]/g, this.options.tokens.project.customFieldLabel39);
		input = input.replace(/\[Project.CustomFieldValue39\]/g, this.options.tokens.project.customFieldValue39);

		input = input.replace(/\[Project.CustomFieldValue26_CompanyName\]/g, this.options.tokens.project.customFieldValue26_CompanyName);
		input = input.replace(/\[Project.CustomFieldValue26_ContactName\]/g, this.options.tokens.project.customFieldValue26_ContactName);
		input = input.replace(/\[Project.CustomFieldValue26_ContactTitle\]/g, this.options.tokens.project.customFieldValue26_ContactTitle);
		input = input.replace(/\[Project.CustomFieldValue26_Address26\]/g, this.options.tokens.project.customFieldValue26_Address26);
		input = input.replace(/\[Project.CustomFieldValue26_Address2\]/g, this.options.tokens.project.customFieldValue26_Address2);
		input = input.replace(/\[Project.CustomFieldValue26_City\]/g, this.options.tokens.project.customFieldValue26_City);
		input = input.replace(/\[Project.CustomFieldValue26_StateProvince\]/g, this.options.tokens.project.customFieldValue26_StateProvince);
		input = input.replace(/\[Project.CustomFieldValue26_PostalCode\]/g, this.options.tokens.project.customFieldValue26_PostalCode);
		input = input.replace(/\[Project.CustomFieldValue26_Country\]/g, this.options.tokens.project.customFieldValue26_Country);
		input = input.replace(/\[Project.CustomFieldValue26_Phone\]/g, this.options.tokens.project.customFieldValue26_Phone);
		input = input.replace(/\[Project.CustomFieldValue26_Fax\]/g, this.options.tokens.project.customFieldValue26_Fax);
		input = input.replace(/\[Project.CustomFieldValue26_Cell\]/g, this.options.tokens.project.customFieldValue26_Cell);
		input = input.replace(/\[Project.CustomFieldValue26_Email\]/g, this.options.tokens.project.customFieldValue26_Email);

		input = input.replace(/\[Project.CustomFieldValue27_CompanyName\]/g, this.options.tokens.project.customFieldValue27_CompanyName);
		input = input.replace(/\[Project.CustomFieldValue27_ContactName\]/g, this.options.tokens.project.customFieldValue27_ContactName);
		input = input.replace(/\[Project.CustomFieldValue27_ContactTitle\]/g, this.options.tokens.project.customFieldValue27_ContactTitle);
		input = input.replace(/\[Project.CustomFieldValue27_Address27\]/g, this.options.tokens.project.customFieldValue27_Address27);
		input = input.replace(/\[Project.CustomFieldValue27_Address2\]/g, this.options.tokens.project.customFieldValue27_Address2);
		input = input.replace(/\[Project.CustomFieldValue27_City\]/g, this.options.tokens.project.customFieldValue27_City);
		input = input.replace(/\[Project.CustomFieldValue27_StateProvince\]/g, this.options.tokens.project.customFieldValue27_StateProvince);
		input = input.replace(/\[Project.CustomFieldValue27_PostalCode\]/g, this.options.tokens.project.customFieldValue27_PostalCode);
		input = input.replace(/\[Project.CustomFieldValue27_Country\]/g, this.options.tokens.project.customFieldValue27_Country);
		input = input.replace(/\[Project.CustomFieldValue27_Phone\]/g, this.options.tokens.project.customFieldValue27_Phone);
		input = input.replace(/\[Project.CustomFieldValue27_Fax\]/g, this.options.tokens.project.customFieldValue27_Fax);
		input = input.replace(/\[Project.CustomFieldValue27_Cell\]/g, this.options.tokens.project.customFieldValue27_Cell);
		input = input.replace(/\[Project.CustomFieldValue27_Email\]/g, this.options.tokens.project.customFieldValue27_Email);

		input = input.replace(/\[Project.CustomFieldValue1_CLBR\]/g, this.options.tokens.project.customFieldValue1_CLBR);
		input = input.replace(/\[Project.CustomFieldValue2_CLBR\]/g, this.options.tokens.project.customFieldValue2_CLBR);
		input = input.replace(/\[Project.CustomFieldValue3_CLBR\]/g, this.options.tokens.project.customFieldValue3_CLBR);
		input = input.replace(/\[Project.CustomFieldValue4_CLBR\]/g, this.options.tokens.project.customFieldValue4_CLBR);
		input = input.replace(/\[Project.CustomFieldValue5_CLBR\]/g, this.options.tokens.project.customFieldValue5_CLBR);
		input = input.replace(/\[Project.CustomFieldValue6_CLBR\]/g, this.options.tokens.project.customFieldValue6_CLBR);
		input = input.replace(/\[Project.CustomFieldValue7_CLBR\]/g, this.options.tokens.project.customFieldValue7_CLBR);
		input = input.replace(/\[Project.CustomFieldValue8_CLBR\]/g, this.options.tokens.project.customFieldValue8_CLBR);
		input = input.replace(/\[Project.CustomFieldValue9_CLBR\]/g, this.options.tokens.project.customFieldValue9_CLBR);
		input = input.replace(/\[Project.CustomFieldValue10_CLBR\]/g, this.options.tokens.project.customFieldValue10_CLBR);
		input = input.replace(/\[Project.CustomFieldValue11_CLBR\]/g, this.options.tokens.project.customFieldValue11_CLBR);
		input = input.replace(/\[Project.CustomFieldValue12_CLBR\]/g, this.options.tokens.project.customFieldValue12_CLBR);
		input = input.replace(/\[Project.CustomFieldValue13_CLBR\]/g, this.options.tokens.project.customFieldValue13_CLBR);
		input = input.replace(/\[Project.CustomFieldValue14_CLBR\]/g, this.options.tokens.project.customFieldValue14_CLBR);
		input = input.replace(/\[Project.CustomFieldValue15_CLBR\]/g, this.options.tokens.project.customFieldValue15_CLBR);
		input = input.replace(/\[Project.CustomFieldValue16_CLBR\]/g, this.options.tokens.project.customFieldValue16_CLBR);
		input = input.replace(/\[Project.CustomFieldValue17_CLBR\]/g, this.options.tokens.project.customFieldValue17_CLBR);
		input = input.replace(/\[Project.CustomFieldValue18_CLBR\]/g, this.options.tokens.project.customFieldValue18_CLBR);
		input = input.replace(/\[Project.CustomFieldValue19_CLBR\]/g, this.options.tokens.project.customFieldValue19_CLBR);
		input = input.replace(/\[Project.CustomFieldValue20_CLBR\]/g, this.options.tokens.project.customFieldValue20_CLBR);
		input = input.replace(/\[Project.CustomFieldValue21_CLBR\]/g, this.options.tokens.project.customFieldValue21_CLBR);
		input = input.replace(/\[Project.CustomFieldValue22_CLBR\]/g, this.options.tokens.project.customFieldValue22_CLBR);
		input = input.replace(/\[Project.CustomFieldValue23_CLBR\]/g, this.options.tokens.project.customFieldValue23_CLBR);
		input = input.replace(/\[Project.CustomFieldValue24_CLBR\]/g, this.options.tokens.project.customFieldValue24_CLBR);
		input = input.replace(/\[Project.CustomFieldValue25_CLBR\]/g, this.options.tokens.project.customFieldValue25_CLBR);
		input = input.replace(/\[Project.CustomFieldValue26_CLBR\]/g, this.options.tokens.project.customFieldValue26_CLBR);
		input = input.replace(/\[Project.CustomFieldValue27_CLBR\]/g, this.options.tokens.project.customFieldValue27_CLBR);
		input = input.replace(/\[Project.CustomFieldValue28_CLBR\]/g, this.options.tokens.project.customFieldValue28_CLBR);
		input = input.replace(/\[Project.CustomFieldValue29_CLBR\]/g, this.options.tokens.project.customFieldValue29_CLBR);
		input = input.replace(/\[Project.CustomFieldValue30_CLBR\]/g, this.options.tokens.project.customFieldValue30_CLBR);
		input = input.replace(/\[Project.CustomFieldValue31_CLBR\]/g, this.options.tokens.project.customFieldValue31_CLBR);
		input = input.replace(/\[Project.CustomFieldValue32_CLBR\]/g, this.options.tokens.project.customFieldValue32_CLBR);
		input = input.replace(/\[Project.CustomFieldValue33_CLBR\]/g, this.options.tokens.project.customFieldValue33_CLBR);
		input = input.replace(/\[Project.CustomFieldValue34_CLBR\]/g, this.options.tokens.project.customFieldValue34_CLBR);
		input = input.replace(/\[Project.CustomFieldValue35_CLBR\]/g, this.options.tokens.project.customFieldValue35_CLBR);
		input = input.replace(/\[Project.CustomFieldValue36_CLBR\]/g, this.options.tokens.project.customFieldValue36_CLBR);
		input = input.replace(/\[Project.CustomFieldValue37_CLBR\]/g, this.options.tokens.project.customFieldValue37_CLBR);
		input = input.replace(/\[Project.CustomFieldValue38_CLBR\]/g, this.options.tokens.project.customFieldValue38_CLBR);
		input = input.replace(/\[Project.CustomFieldValue39_CLBR\]/g, this.options.tokens.project.customFieldValue39_CLBR);

		input = input.replace(/\[BidForms.GroupDueDates\]/g, this.options.tokens.bidForms.groupDueDates);

		input = input.replace(/\[ProjectContacts.UserType395_CompanyName\]/g, this.options.tokens.projectContacts.userType395_CompanyName);
		input = input.replace(/\[ProjectContacts.UserType395_ContactName\]/g, this.options.tokens.projectContacts.userType395_ContactName);
		input = input.replace(/\[ProjectContacts.UserType395_ContactTitle\]/g, this.options.tokens.projectContacts.userType395_ContactTitle);
		input = input.replace(/\[ProjectContacts.UserType395_Address26\]/g, this.options.tokens.projectContacts.userType395_Address);
		input = input.replace(/\[ProjectContacts.UserType395_Address2\]/g, this.options.tokens.projectContacts.userType395_Address2);
		input = input.replace(/\[ProjectContacts.UserType395_City\]/g, this.options.tokens.projectContacts.userType395_City);
		input = input.replace(/\[ProjectContacts.UserType395_StateProvince\]/g, this.options.tokens.projectContacts.userType395_StateProvince);
		input = input.replace(/\[ProjectContacts.UserType395_PostalCode\]/g, this.options.tokens.projectContacts.userType395_PostalCode);
		input = input.replace(/\[ProjectContacts.UserType395_Country\]/g, this.options.tokens.projectContacts.userType395_Country);
		input = input.replace(/\[ProjectContacts.UserType395_Phone\]/g, this.options.tokens.projectContacts.userType395_Phone);
		input = input.replace(/\[ProjectContacts.UserType395_Fax\]/g, this.options.tokens.projectContacts.userType395_Fax);
		input = input.replace(/\[ProjectContacts.UserType395_Cell\]/g, this.options.tokens.projectContacts.userType395_Cell);
		input = input.replace(/\[ProjectContacts.UserType395_Email\]/g, this.options.tokens.projectContacts.userType395_Email);

		input = input.replace(/\[ProjectContacts.UserType396_CompanyName\]/g, this.options.tokens.projectContacts.userType396_CompanyName);
		input = input.replace(/\[ProjectContacts.UserType396_ContactName\]/g, this.options.tokens.projectContacts.userType396_ContactName);
		input = input.replace(/\[ProjectContacts.UserType396_ContactTitle\]/g, this.options.tokens.projectContacts.userType396_ContactTitle);
		input = input.replace(/\[ProjectContacts.UserType396_Address26\]/g, this.options.tokens.projectContacts.userType396_Address);
		input = input.replace(/\[ProjectContacts.UserType396_Address2\]/g, this.options.tokens.projectContacts.userType396_Address2);
		input = input.replace(/\[ProjectContacts.UserType396_City\]/g, this.options.tokens.projectContacts.userType396_City);
		input = input.replace(/\[ProjectContacts.UserType396_StateProvince\]/g, this.options.tokens.projectContacts.userType396_StateProvince);
		input = input.replace(/\[ProjectContacts.UserType396_PostalCode\]/g, this.options.tokens.projectContacts.userType396_PostalCode);
		input = input.replace(/\[ProjectContacts.UserType396_Country\]/g, this.options.tokens.projectContacts.userType396_Country);
		input = input.replace(/\[ProjectContacts.UserType396_Phone\]/g, this.options.tokens.projectContacts.userType396_Phone);
		input = input.replace(/\[ProjectContacts.UserType396_Fax\]/g, this.options.tokens.projectContacts.userType396_Fax);
		input = input.replace(/\[ProjectContacts.UserType396_Cell\]/g, this.options.tokens.projectContacts.userType396_Cell);
		input = input.replace(/\[ProjectContacts.UserType396_Email\]/g, this.options.tokens.projectContacts.userType396_Email);

		return input;
	},
	export: function () {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.project.get('projectId')
				},
				{
					endpoint: 'projectmessagepreview'
				},
				{
					endpoint: 'export'
				}
			]),
			data: {
				templateKey: this.options.project.inviteSettings.emailTemplate.get('templateKey'),
				responseType: encodeURIComponent(this.options.tokens.projectMessage.responseType),
				bidDueDate: this.options.tokens.projectMessage.bidDueDate,
				responseDueDate: this.options.tokens.projectMessage.responseDueDate,
				messageSubject: encodeURIComponent(this.options.inviteSettings.messageSubject),
				messageBody: encodeURIComponent(this.options.tokens.projectMessage.messageBody)
			}
		}).post().success(_.bind(function (data) {
			PJQ.files.downloadFile(data.url, {isEndpoint: false});
		}, this));
	}
});
